"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LastMileDeliveryMixin = void 0;

require("core-js/modules/es6.array.sort");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.regexp.to-string");

var _defineProperty2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));

require("core-js/modules/es6.function.name");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.set");

var _toConsumableArray2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));

require("core-js/modules/es6.array.find");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.array.find-index");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuexClass = require("vuex-class");

var _vuePropertyDecorator = require("vue-property-decorator");

var _elementUi = require("element-ui");

var _moment = _interopRequireDefault(require("moment"));

var _helper = require("@/mixins/helper/helper");

var _logger = require("@/mixins/logger/logger");

var _userLogs = require("@/mixins/user-logs/user-logs");

var _route = require("@/api/route.api");

var _lastMileDeliveryWellcome = require("@/api/last-mile-delivery-wellcome.api");

var _socketV = require("@/api/socket-v2.api");

var _plan = require("@/api/plan.api");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DEFAULT_TRUCK_WORKING_HOURS = [process.env.VUE_APP_DEFAULT_START_WORKINGHR, process.env.VUE_APP_DEFAULT_END_WORKINGHR];

var LastMileDeliveryMixin = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(LastMileDeliveryMixin, _Mixins);

  var _super = _createSuper(LastMileDeliveryMixin);

  function LastMileDeliveryMixin() {
    var _this;

    (0, _classCallCheck2.default)(this, LastMileDeliveryMixin);
    _this = _super.apply(this, arguments);
    _this.disableTruckKey = process.env.VUE_APP_DISABLE_TRUCK_KEY;
    return _this;
  } // disableTruckList: any[] = [];


  (0, _createClass2.default)(LastMileDeliveryMixin, [{
    key: "isViewOnly",
    get: function get() {
      /*const isAdmin = this.$userInformation.isAdmin;
      const permissionList = this.helper.get(this.$userInformation, 'user.permission', []);
      let isModifyAllowed: boolean = false;
       if (permissionList.length > 0) {
          const isModify = Boolean(
              this.helper.get(
                  permissionList.filter((i) => i.Value === '0900'),
                  '0.Modify',
                  false
              )
          );
          const isAccess = Boolean(
              this.helper.get(
                  permissionList.filter((i) => i.Value === '0900'),
                  '0.Access',
                  false
              )
          );
           isModifyAllowed = isAdmin || isModify || !(!isModify && isAccess);
      }
       return !isModifyAllowed || this.isOccupied;*/
      return this.isOccupied;
    }
  }, {
    key: "isOccupied",
    get: function get() {
      return this.$isOccupied;
    },
    set: function set(newVal) {
      this.$setIsOccupied(newVal);
    }
  }, {
    key: "occupyingUsername",
    get: function get() {
      return this.$occupyingUsername;
    },
    set: function set(newVal) {
      this.$setOccupyingUsername(newVal);
    }
  }, {
    key: "occupyingRoute",
    get: function get() {
      return this.$occupyingRoute;
    },
    set: function set(newVal) {
      this.$setOccupyingRoute(newVal);
    }
  }, {
    key: "occupyingMessage",
    get: function get() {
      var routeUser = this.occupyingUsername ? this.occupyingUsername : this.$t('planning.messages.someone');
      var routeName = this.occupyingRoute === 'lmdV2ManualAssign' || this.occupyingRoute === 'lmdPriceriteManualAssign' || this.occupyingRoute === 'lmdWellcomeManualAssign' ? this.$t('planning.messages.manualAssignOccupied') : this.$t('planning.messages.autoAssignOccupied');
      return "".concat(routeUser, " ").concat(routeName);
    }
  }, {
    key: "$socketId",
    get: function get() {
      return this.$store.getters['common/socketId'];
    },
    set: function set(newVal) {
      this.$setSocketId(newVal);
    }
  }, {
    key: "$timezone",
    get: function get() {
      return this.helper.get(this.$userData, 'timezone', 8);
    }
  }, {
    key: "$isMobile",
    get: function get() {
      return this.$store.getters['common/isMobile'];
    },
    set: function set(newVal) {
      this.$setIsMobile(newVal);
    }
  }, {
    key: "isSomeOrdersAssigned",
    get: function get() {
      if (this.$plan && this.$plan.trucks && this.$plan.trucks.length > 0) {
        return this.$plan.trucks.some(function (truck) {
          return truck.routes.some(function (route) {
            return route.status.toUpperCase() === 'ASSIGNED' || route.status.toUpperCase() === 'COMPLETED';
          });
        });
      }

      return false;
    }
  }, {
    key: "truckPlanIds",
    get: function get() {
      var truck = this.getTruckInPlan(this.$selectedTruck);

      if (this.$selectedTruck && truck) {
        return truck['planId'].length === 0 && truck['routes'].length > 0 ? [''] : truck['planId'];
      }

      return [];
    }
  }, {
    key: "disableTruckList",
    get: function get() {
      return this.$store.getters['lastMileDeliveryWellcome/disableTruckList'];
    },
    set: function set(newVal) {
      this.$setDisableTruckList(newVal);
    }
  }, {
    key: "$trucks",
    get: function get() {
      return this.$store.getters['lastMileDeliveryWellcome/trucks'];
    },
    set: function set(newVal) {
      this.$setTrucks(newVal);
    }
  }, {
    key: "$bufferTrucks",
    get: function get() {
      return this.$store.getters['lastMileDeliveryWellcome/bufferTrucks'];
    },
    set: function set(newVal) {
      this.$setBufferTrucks(newVal);
    }
  }, {
    key: "$GLOBAL_ACTIVE_USERS",
    get: function get() {
      return this.$store.getters['lastMileDeliveryWellcome/GLOBAL_ACTIVE_USERS'];
    },
    set: function set(newVal) {
      this.$setGlobalActiveUsers(newVal);
    }
  }, {
    key: "$GLOBAL_SELECTED_ORDERS",
    get: function get() {
      return this.$store.getters['lastMileDeliveryWellcome/GLOBAL_SELECTED_ORDERS'];
    },
    set: function set(newVal) {
      this.$setGlobalSelectedOrders(newVal);
    }
  }, {
    key: "$GLOBAL_SELECTED_TRUCKS",
    get: function get() {
      return this.$store.getters['lastMileDeliveryWellcome/GLOBAL_SELECTED_TRUCKS'];
    },
    set: function set(newVal) {
      this.$setGlobalSelectedTrucks(newVal);
    }
  }, {
    key: "$failedOrders",
    get: function get() {
      return this.$store.getters['lastMileDeliveryWellcome/failedOrders'];
    },
    set: function set(newVal) {
      this.$setFailedOrders(newVal);
    }
  }, {
    key: "$removedTruckIds",
    get: function get() {
      return this.$store.getters['lastMileDeliveryWellcome/removedTruckIds'];
    },
    set: function set(newVal) {
      this.$setRemovedTruckIds(newVal);
    }
  }, {
    key: "$orderColumnTemplates",
    get: function get() {
      return this.$store.getters['lastMileDeliveryWellcome/orderColumnTemplates'];
    },
    set: function set(newVal) {
      this.$setOrderColumnTemplates(newVal);
    }
  }, {
    key: "isManualAssignLoading",
    get: function get() {
      return this.$store.getters['lastMileDeliveryWellcome/isManualAssignLoading'];
    },
    set: function set(newVal) {
      this.$setIsManualAssignLoading(newVal);
    }
  }, {
    key: "isAutoAssignLoading",
    get: function get() {
      return this.$store.getters['lastMileDeliveryWellcome/isAutoAssignLoading'];
    },
    set: function set(newVal) {
      this.$setIsAutoAssignLoading(newVal);
    }
  }, {
    key: "$isAssignedDriverChanges",
    get: function get() {
      return this.$store.getters['lastMileDeliveryWellcome/isAssignedDriverChanges'];
    },
    set: function set(newVal) {
      this.$setIsAssignedDriverChanges(newVal);
    }
  }, {
    key: "$toBeUnassignedOrderIds",
    get: function get() {
      return this.$store.getters['lastMileDeliveryWellcome/toBeUnassignedOrderIds'];
    },
    set: function set(newVal) {
      this.$setToBeUnassignedOrderIds(newVal);
    }
  }, {
    key: "$dateRangeOption",
    get: function get() {
      return this.$store.getters['lastMileDeliveryWellcome/dateRangeOption'];
    },
    set: function set(newVal) {
      this.$setDateRangeOption(newVal);
    }
  }, {
    key: "$pagination",
    get: function get() {
      return this.$store.getters['lastMileDeliveryWellcome/pagination'];
    },
    set: function set(newVal) {
      this.$setPagination(newVal);
    }
  }, {
    key: "$startDate",
    get: function get() {
      return this.$store.getters['lastMileDeliveryWellcome/startDate'];
    },
    set: function set(newVal) {
      this.$setStartDate(newVal);
    }
  }, {
    key: "$endDate",
    get: function get() {
      return this.$store.getters['lastMileDeliveryWellcome/endDate'];
    },
    set: function set(newVal) {
      this.$setEndDate(newVal);
    }
  }, {
    key: "$dateRange",
    get: function get() {
      return [this.$startDate, this.$endDate];
    },
    set: function set(newVal) {
      if (newVal) {
        this.$setDateRange({
          startDate: newVal[0],
          endDate: newVal[1]
        });
      }
    }
  }, {
    key: "$planDate",
    get: function get() {
      return this.$store.getters['lastMileDeliveryWellcome/planDate'];
    },
    set: function set(newVal) {
      this.$setPlanDate(newVal);
    }
  }, {
    key: "$truckLoading",
    get: function get() {
      return this.$store.getters['lastMileDeliveryWellcome/truckLoading'];
    },
    set: function set(newVal) {
      this.$setTruckLoading(newVal);
    }
  }, {
    key: "$locationType",
    get: function get() {
      return this.$store.getters['lastMileDeliveryWellcome/locationType'];
    },
    set: function set(newVal) {
      this.$setLocationType(newVal);
    }
  }, {
    key: "$searchType",
    get: function get() {
      return this.$store.getters['lastMileDeliveryWellcome/searchType'];
    },
    set: function set(newVal) {
      this.$setSearchType(newVal);
    }
  }, {
    key: "$selectedTruck",
    get: function get() {
      return this.$store.getters['lastMileDeliveryWellcome/selectedTruck'];
    },
    set: function set(newVal) {
      this.$setSelectedTruck(newVal);
    }
  }, {
    key: "$selectedLocation",
    get: function get() {
      return this.$store.getters['lastMileDeliveryWellcome/selectedLocation'];
    },
    set: function set(newVal) {
      this.$setSelectedLocation(newVal);
    }
  }, {
    key: "$unassignedOrders",
    get: function get() {
      return this.$store.getters['lastMileDeliveryWellcome/unassignedOrders'];
    },
    set: function set(newVal) {
      this.$setUnassignedOrders(newVal);
    }
  }, {
    key: "$excludedOrders",
    get: function get() {
      return this.$store.getters['lastMileDeliveryWellcome/excludedOrders'];
    },
    set: function set(newVal) {
      this.$setExcludedOrders(newVal);
    }
  }, {
    key: "$includedOrders",
    get: function get() {
      return this.$store.getters['lastMileDeliveryWellcome/includedOrders'];
    },
    set: function set(newVal) {
      this.$setIncludedOrders(newVal);
    }
  }, {
    key: "$selectedOrders",
    get: function get() {
      return this.$store.getters['lastMileDeliveryWellcome/selectedOrders'];
    },
    set: function set(newVal) {
      this.$setSelectedOrders(newVal);
    }
  }, {
    key: "$orderFilters",
    get: function get() {
      return this.$store.getters['lastMileDeliveryWellcome/orderFilters'];
    },
    set: function set(newVal) {
      this.$setOrderFilters(newVal);
    }
  }, {
    key: "$selectedColumns",
    get: function get() {
      return this.$store.getters['lastMileDeliveryWellcome/selectedColumns'];
    },
    set: function set(newVal) {
      this.$setSelectedColumns(newVal);
    }
  }, {
    key: "driversList",
    get: function get() {
      var _this2 = this;

      return this.helper.orderBy(this.$drivers, [function (driver) {
        return driver['UserName'].toLowerCase();
      }], ['asc']).filter(function (driver) {
        return !_this2.blockedDrivers.includes(driver.RecId);
      });
    }
  }, {
    key: "$selectedDriver",
    get: function get() {
      return this.$store.getters['lastMileDeliveryWellcome/selectedDriver'];
    },
    set: function set(newVal) {
      this.$setSelectedDriver(newVal);
    }
  }, {
    key: "$anyChanges",
    get: function get() {
      return this.$store.getters['lastMileDeliveryWellcome/anyChanges'];
    },
    set: function set(newVal) {
      this.$setAnyChanges(newVal);
    }
  }, {
    key: "$isPlanExists",
    get: function get() {
      return this.$store.getters['lastMileDeliveryWellcome/isPlanExists'];
    },
    set: function set(newVal) {
      this.$setPlanExists(newVal);
    }
  }, {
    key: "locked",
    get: function get() {
      var _this3 = this;

      return this.helper.get(this.helper.filter(this.$trucks, function (truck) {
        return truck['id'] === _this3.$selectedTruck;
      }), '0.locked', true);
    },
    set: function set(newVal) {
      var _this4 = this;

      if (this.$selectedTruck && this.$plan.trucks.length > 0) {
        var plan = this.helper.cloneDeep(this.$plan);
        var index = this.helper.findIndex(plan['trucks'], function (truck) {
          return truck['truckId'] === _this4.$selectedTruck;
        });

        if (index !== -1) {
          plan['trucks'][index]['locked'] = newVal;
        }

        this.$setPlan({
          plan: plan
        });
      }
    }
  }, {
    key: "currTruck",
    get: function get() {
      var _this5 = this;

      return this.helper.get(this.$trucks.filter(function (tData) {
        return tData['id'] === _this5.$selectedTruck;
      }), '0', null);
    }
  }, {
    key: "currPlanTruck",
    get: function get() {
      var _this6 = this;

      if (!this.$plan.trucks || this.$plan.trucks.length === 0) {
        return null;
      }

      return this.helper.get(this.$plan.trucks.filter(function (tData) {
        return tData['truckId'] === _this6.$selectedTruck;
      }), '0', null);
    }
  }, {
    key: "$truckFilters",
    get: function get() {
      return this.$store.getters['lastMileDeliveryWellcome/truckFilters'];
    },
    set: function set(newVal) {
      this.$setTruckFilters(newVal);
    }
  }, {
    key: "blockedDrivers",
    get: function get() {
      return this.helper.get(this.$userInformation, 'blockedDrivers', []);
    }
  }, {
    key: "routes",
    get: function get() {
      return this.getRoutes(this.$selectedTruck);
    },
    set: function set(newVal) {
      var _this7 = this;

      if (this.$selectedTruck && this.$plan.trucks.length > 0) {
        var plan = this.helper.cloneDeep(this.$plan);
        var index = this.helper.findIndex(plan['trucks'], function (truck) {
          return truck['truckId'] === _this7.$selectedTruck;
        });

        if (index !== -1) {
          plan['trucks'][index]['routes'] = newVal;
        }

        this.$setPlan({
          plan: plan
        });
      }
    }
  }, {
    key: "$defaultTime",
    get: function get() {
      var startTime = this.$userSetting['default6'] || null;

      if (startTime) {
        return (0, _moment.default)(new Date()).format('YYYY-MM-DD') === this.$planDate ? (0, _moment.default)(new Date()).format("YYYY-MM-DD ".concat(startTime)) : (0, _moment.default)(this.$planDate).format("YYYY-MM-DD ".concat(startTime));
      }

      return (0, _moment.default)(new Date()).format('YYYY-MM-DD') === this.$planDate ? (0, _moment.default)(new Date()).format('YYYY-MM-DD HH:mm:00') : (0, _moment.default)(this.$planDate).format('YYYY-MM-DD 09:00:00');
    }
  }, {
    key: "hasToteboxDry",
    get: function get() {
      var bool = false;
      var default12 = this.helper.isNotEmpty(this.$userSetting['default12']) ? this.$userSetting['default12'].split('|') : [];

      if (default12.length >= 1 && this.helper.isInArray('capacity4', default12)) {
        bool = true;
      }

      return bool;
    }
  }, {
    key: "hasToteboxWet",
    get: function get() {
      var bool = false;
      var default12 = this.helper.isNotEmpty(this.$userSetting['default12']) ? this.$userSetting['default12'].split('|') : [];

      if (default12.length >= 1 && this.helper.isInArray('capacity5', default12)) {
        bool = true;
      }

      return bool;
    }
  }, {
    key: "hasAssemblyMinutes",
    get: function get() {
      var hasAssemblyMinute = false;
      var default12 = this.helper.isNotEmpty(this.$userSetting['default12']) ? this.$userSetting['default12'].split('|') : [];

      if (default12.length >= 1 && this.helper.isInArray('capacity3', default12)) {
        hasAssemblyMinute = true;
      }

      return hasAssemblyMinute;
    }
  }, {
    key: "created",
    value: function created() {
      if (!this.routeAPI) {
        this.routeAPI = new _route.RouteAPI({
          customerKey: this.$userInformation.customerKey || '',
          userSetting: this.$userSetting
        });
      }

      if (!this.lastMileDeliveryAPI) {
        this.lastMileDeliveryAPI = new _lastMileDeliveryWellcome.LastMileDeliveryWellcomeAPI({
          customerKey: this.$userInformation.customerKey || '',
          userInformation: this.$userInformation,
          userSetting: this.$userSetting,
          lfToken: this.$lfToken || null
        });
      }

      if (!this.socketAPI) {
        this.socketAPI = new _socketV.SocketAPI({
          lfToken: this.$lfToken || '',
          customerKey: this.$userInformation.customerKey || ''
        });
      }

      if (!this.planAPI) {
        this.planAPI = new _plan.PlanAPI({
          userSetting: this.$userSetting,
          lfCustKey: this.$lfCustKey || null,
          lfAPIToken: this.$lfAPIToken || null
        });
      }
    }
  }, {
    key: "getOrders",
    value: function getOrders() {
      var _this8 = this;

      var orderData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var code = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'save';
      var finalOrders = [];

      switch (type) {
        case 'save':
          if (orderData['data'] && orderData['data'].length >= 1) {
            orderData['data'].forEach(function (oData) {
              if (oData['routes'] && oData['routes'].length >= 1) {
                oData['routes'].forEach(function (rData) {
                  var finalOrder = finalOrders.length >= 1 ? finalOrders.find(function (fOrder) {
                    return fOrder['planId'] === rData['planId'];
                  }) : null;

                  if (finalOrder) {
                    finalOrder['orderId'] = (0, _toConsumableArray2.default)(new Set([].concat((0, _toConsumableArray2.default)(finalOrder['orderId']), (0, _toConsumableArray2.default)(rData['orderId']))));
                  } else {
                    if (rData['planId'] && rData['orderId']) {
                      finalOrders.push({
                        planCode: code,
                        planId: rData['planId'],
                        orderId: (0, _toConsumableArray2.default)(new Set(rData['orderId']))
                      });
                    }
                  }
                });
              }
            });
          }

          break;

        case 'deleteAll':
          if (orderData['orders'] && orderData['orders'].length >= 1) {
            var orderIds = orderData['orders'].reduce(function (orderId, oData) {
              if (oData['id']) {
                orderId.push(oData['id']);
              }

              return orderId;
            }, []);
            finalOrders.push({
              planCode: '',
              planId: '',
              orderId: orderIds
            });
          }

          break;

        case 'deleteTruck':
          if (orderData['trucks'] && orderData['trucks'].length >= 1) {
            var _orderIds = orderData['trucks'].reduce(function (orderId, oData) {
              if (oData['orderId'].length >= 1 && oData['truckId'] === _this8.$selectedTruck) {
                orderId = [].concat((0, _toConsumableArray2.default)(orderId), (0, _toConsumableArray2.default)(oData['orderId']));
              }

              return orderId;
            }, []);

            finalOrders.push({
              planCode: '',
              planId: '',
              orderId: _orderIds
            });
          }

          break;

        case 'deleteOnList':
          if (orderData['orderId'] && orderData['orderId'].length >= 1) {
            finalOrders.push({
              planCode: '',
              planId: '',
              orderId: orderData['orderId']
            });
          }

          break;
      }

      if (this.$includedOrders && this.$includedOrders.length >= 1) {
        finalOrders.push({
          planCode: '',
          planId: '',
          orderId: this.$includedOrders
        });
      }

      return finalOrders;
    }
  }, {
    key: "isInvalidOrder",
    value: function isInvalidOrder(order) {
      var bool = false;

      if (order.waypoints && order.waypoints.length >= 2) {
        if (this.helper.every(order['waypoints'], function (i) {
          return i['waypointType'] === 'P';
        })) {
          return true;
        }

        if (this.helper.every(order['waypoints'], function (i) {
          return i['waypointType'] === 'D';
        })) {
          return true;
        }

        this.helper.forEach(order['waypoints'], function (waypoint) {
          /*let isAssemblyTimeInvalid: boolean = false;
          let isToteBoxInvalid: boolean = false;
           if (!this.helper.isUndefined(this.$userSetting.default12)) {
              const additionalConstraints = this.$userSetting.default12.split('|');
              isAssemblyTimeInvalid = additionalConstraints.includes('capacity3') ? parseInt(order['assemblyMinutes'], 10) === 0 : false;
              isToteBoxInvalid = additionalConstraints.includes('capacity4') || additionalConstraints.includes('capacity5') ?
                  parseInt(order['toteBoxDry'], 10) === 0 && parseInt(order['toteBoxWet'], 10) === 0 :
                  false;
          }*/
          if (parseFloat(waypoint['latitude']) === 0 || parseFloat(waypoint['longitude']) === 0 || parseFloat(order['weight']) === 0 // isToteBoxInvalid ||
          // isAssemblyTimeInvalid
          ) {
            bool = true;
          }
        });
      } else {
        bool = true;
      }

      return bool;
    }
  }, {
    key: "getInvalidOrderDetails",
    value: function getInvalidOrderDetails(order) {
      var reason = {
        reason1: false,
        reason2: false,
        reason3: false,
        reason4: false,
        reason5: false,
        reason6: false,
        reason7: false,
        reason8: false,
        reason9: false,
        reason10: false
      };

      if (order['waypoints'].length < 2) {
        reason.reason1 = true;
      } else {
        if (this.helper.every(order['waypoints'], function (i) {
          return i['waypointType'] === 'P';
        })) {
          reason.reason2 = true;
        }

        if (this.helper.every(order['waypoints'], function (i) {
          return i['waypointType'] === 'D';
        })) {
          reason.reason2 = true;
        }

        this.helper.forEach(order['waypoints'], function (waypoint) {
          if (parseFloat(waypoint['latitude']) === 0 || parseFloat(waypoint['longitude']) === 0) {
            reason.reason3 = true;
          }
          /*if (parseFloat(order['volume']) === 0) {
              reason.reason4 = true;
          }*/


          if (parseFloat(order['weight']) === 0) {
            reason.reason5 = true;
          }
        });

        if (this.helper.some(order['waypoints'], function (i) {
          return i['completedTime'] !== '0000-00-00 00:00:00' && i['completedTime'] !== null;
        })) {
          reason.reason6 = true;
        }
        /*const additionalConstraints = this.$userSetting.default12.split('|');
        if (additionalConstraints.includes('capacity3')) {
            reason.reason7 = parseInt(order['assemblyMinutes'], 10) === 0;
        }*/

        /*if (additionalConstraints.includes('capacity4')) {
            reason.reason8 = parseInt(order['toteBoxDry'], 10) === 0;
        }
         if (additionalConstraints.includes('capacity5')) {
            reason.reason9 = parseInt(order['toteBoxWet'], 10) === 0;
        }*/

        /*if (additionalConstraints.includes('capacity4') || additionalConstraints.includes('capacity5')) {
            reason.reason10 = parseInt(order['toteBoxDry'], 10) === 0 && parseInt(order['toteBoxWet'], 10) === 0;
        }*/

      }

      return reason;
    }
  }, {
    key: "formatRoutes",
    value: function formatRoutes(routes) {
      var isCalculateETA = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return routes.map(function (routeData) {
        routeData['startTime'] = isCalculateETA ? routeData['startTime'] : null;
        routeData['estimateTime'] = isCalculateETA ? routeData['estimateTime'] : null;
        return routeData;
      });
    }
  }, {
    key: "getTruckInfo",
    value: function getTruckInfo(truckId) {
      return this.helper.get(this.$trucks.filter(function (tData) {
        return tData['id'] === truckId;
      }), '0', null);
    }
  }, {
    key: "getTruckInPlan",
    value: function getTruckInPlan(truckId) {
      return this.helper.get(this.helper.filter(this.$plan.trucks, function (truck) {
        return truck['truckId'] === truckId;
      }), '0', null);
    }
  }, {
    key: "getRoutes",
    value: function getRoutes(truckId) {
      return this.helper.get(this.helper.filter(this.$plan.trucks, function (truck) {
        return truck['truckId'] === truckId;
      }), '0.routes', []);
    }
  }, {
    key: "getTruckPlanIdsByTruckId",
    value: function getTruckPlanIdsByTruckId(truckId) {
      var truck = this.getTruckInPlan(truckId);

      if (truckId && truck) {
        return truck['planId'].length === 0 && truck['routes'].length > 0 ? [''] : truck['planId'];
      }

      return [];
    }
  }, {
    key: "getWaypointsFromIds",
    value: function getWaypointsFromIds(waypointIds) {
      var _this9 = this;

      var waypoints = [];
      var orderIds = this.helper.uniq(this.helper.map(waypointIds, function (id) {
        return parseInt(id.split('-')[0], 10);
      }));
      var filteredOrders = this.helper.filter(this.$plan['orders'], function (order) {
        return _this9.helper.includes(orderIds, parseInt(order['id'], 10));
      });
      this.helper.forEach(filteredOrders, function (order) {
        _this9.helper.forEach(order['waypoints'], function (waypoint) {
          _this9.helper.forEach(waypointIds, function (wpId) {
            if (waypoint['id'] === wpId) {
              waypoints.push(waypoint);
              return false;
            }
          });
        });
      });
      return filteredOrders.length > 0 ? waypoints : [];
    }
  }, {
    key: "getWaypointFromId",
    value: function getWaypointFromId(waypointId, fieldName) {
      var orderId = parseInt(waypointId.split('-')[0], 10) || null;
      var waypointIndex = parseInt(waypointId.split('-')[1], 10) || null;

      if (!orderId || !waypointIndex) {
        return null;
      }

      var order = this.$plan['orders'].filter(function (o) {
        return o['id'] === orderId;
      });

      if (!order || order.length === 0) {
        return '';
      }

      var waypoint = this.helper.find(order[0].waypoints, function (wp) {
        return wp.id === waypointId;
      });

      if (!waypoint || waypoint.length === 0) {
        return '';
      }

      return waypoint[fieldName];
    }
  }, {
    key: "getOrderField",
    value: function getOrderField(orderId, fieldName) {
      var selectedOrder = this.helper.get(this.helper.filter(this.$plan['orders'], function (order) {
        return order['id'] === parseInt(orderId, 10);
      }), '0', null);

      if (selectedOrder) {
        return selectedOrder[fieldName];
      }

      return null;
    }
  }, {
    key: "getOrdersField",
    value: function getOrdersField(orderIds, fieldName) {
      var _this10 = this;

      var filteredOrders = this.$plan.orders.filter(function (o) {
        return orderIds.includes(o.id);
      });

      if (this.helper.isUndefined(filteredOrders) || filteredOrders.length === 0) {
        return [];
      }

      return filteredOrders.map(function (o) {
        return o[fieldName];
      }).filter(function (v) {
        return !_this10.helper.isUndefined(v);
      });
    }
  }, {
    key: "adhocAssign",
    value: function () {
      var _adhocAssign = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data) {
        var isNewTruckObj,
            param,
            payload,
            truckObj,
            tType,
            res,
            message,
            response,
            invalidReasons,
            invalidRes,
            _message,
            _args = arguments;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                isNewTruckObj = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;
                param = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
                truckObj = this.getTruckInPlan(data['truck']['id']);
                tType = this.helper.get(truckObj, 'type', 'MANUALASSIGN');

                if (isNewTruckObj) {
                  payload = {
                    company: this.$userInformation.company.name,
                    user: this.$userInformation.user.name,
                    code: this.$planDate,
                    startDateTime: this.helper.revertTimezone(data['startTime'], this.$timezone, 'YYYY-MM-DD 00:00:00'),
                    routes: data['orders'],
                    vehicles: [_objectSpread(_objectSpread({}, data['truck']), {}, {
                      type: tType,
                      code: data['truck']['truckId'],
                      zone: data['truck']['zone'],
                      truckCommodityType: data['truck']['truckCommodityType'],
                      plateNumber: data['truck']['plateNumber'],
                      capacity1: parseFloat(data['truck']['weight']),
                      capacity2: parseFloat(data['truck']['volume']),
                      capacity3: parseFloat(data['truck']['assemblyMinutes']),
                      workingHours: data['truck']['workingHours'] || DEFAULT_TRUCK_WORKING_HOURS,
                      driverId: this.$selectedDriver,
                      currentDriverId: this.$selectedDriver[0] || null
                    })],
                    planId: data['planId']
                  };
                } else {
                  payload = {
                    company: this.$userInformation.company.name,
                    user: this.$userInformation.user.name,
                    code: this.$planDate,
                    startDateTime: this.helper.revertTimezone(data['startTime'], this.$timezone, 'YYYY-MM-DD 00:00:00'),
                    routes: data['orders'],
                    vehicles: [_objectSpread(_objectSpread({}, data['truck']), {}, {
                      type: tType,
                      currentDriverId: data['truck']['driverId'][0] || null
                    })],
                    planId: data['planId']
                  };
                }

                _context.next = 7;
                return this.lastMileDeliveryAPI.adhocAssign(payload, _objectSpread({}, param));

              case 7:
                res = _context.sent;

                if (data['truck'] && res && !res.failed && !this.helper.isUndefined(res.data) && res.data.vehicles.length) {
                  _context.next = 12;
                  break;
                }

                message = {
                  title: this.$i18n.t('planning.messages.noSolution'),
                  duration: 5000
                };

                _elementUi.Notification.error(message);

                return _context.abrupt("return", null);

              case 12:
                response = res.data;
                invalidReasons = [];
                invalidRes = (0, _toConsumableArray2.default)(response['invalid']);

                if (invalidRes.length > 0) {
                  _message = {
                    title: this.$i18n.t('planning.messages.successInvalidRoutes'),
                    duration: 5000
                  };

                  _elementUi.Notification.success(_message); // NOTE: fix grouping logic is on backend


                  invalidReasons = invalidRes.map(function (irData) {
                    return {
                      code: irData['code'] || '',
                      type: irData['type'] || '',
                      reason: irData['reason'] || '',
                      orderId: irData['orderId'] || [],
                      shipmentReference: irData['shipmentReference'] || [],
                      plateNumber: irData['plateNumber'] || [],
                      vehicleId: irData['vehicleId'] || []
                    };
                  });
                }

                return _context.abrupt("return", {
                  invalidReasons: invalidReasons,
                  invalidOrderIds: response['invalidOrder'],
                  vehicles: response.vehicles
                });

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function adhocAssign(_x) {
        return _adhocAssign.apply(this, arguments);
      }

      return adhocAssign;
    }()
  }, {
    key: "manualAssign",
    value: function () {
      var _manualAssign = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(data, isTransfer) {
        var truckId, truckInPlan, routes, truckObj, tType, res, invalid, message, response, invalidReasons, _message2, _message3;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // let cleanRoutes = [];
                truckId = this.helper.get(data, 'truck.id', null);
                truckInPlan = this.getTruckInPlan(truckId);
                routes = this.helper.get(truckInPlan, 'routes', []); // if (routes.length > 0) {
                // 	cleanRoutes = [...routes];
                // }

                truckObj = this.getTruckInPlan(data['truck']['id']);
                tType = this.helper.get(truckObj, 'type', 'MANUALASSIGN');
                _context2.next = 7;
                return this.lastMileDeliveryAPI.manualAssign({
                  company: this.$userInformation.company.name,
                  user: this.$userInformation.user.name,
                  code: this.$planDate,
                  startDateTime: this.helper.revertTimezone(data['startTime'], this.$timezone, 'YYYY-MM-DD 00:00:00'),
                  routes: data['orders'],
                  vehicles: [_objectSpread(_objectSpread({}, data['truck']), {}, {
                    type: tType,
                    code: data['truck']['truckId'],
                    zone: data['truck']['zone'],
                    truckCommodityType: data['truck']['truckCommodityType'],
                    plateNumber: data['truck']['plateNumber'],
                    capacity1: parseFloat(data['truck']['weight']),
                    capacity2: parseFloat(data['truck']['volume']),
                    capacity3: parseFloat(data['truck']['assemblyMinutes']),
                    workingHours: data['truck']['workingHours'] || DEFAULT_TRUCK_WORKING_HOURS,
                    driverId: this.$selectedDriver,
                    currentDriverId: this.$selectedDriver,
                    overideStartDateTime: data['overideStartDateTime'] || null
                  })],
                  planId: data['planId']
                }, {}, isTransfer);

              case 7:
                res = _context2.sent;
                invalid = (0, _toConsumableArray2.default)(res.data['invalid'] || []);

                if (!(!(data.truck && res && !res.failed && !this.helper.isUndefined(res.data) && res.data.vehicles.length) && invalid.length === 0)) {
                  _context2.next = 13;
                  break;
                }

                message = {
                  title: this.$i18n.t('planning.messages.noSolution'),
                  duration: 5000
                };

                _elementUi.Notification.error(message);

                return _context2.abrupt("return", null);

              case 13:
                response = res.data;
                invalidReasons = [];

                if (invalid.length > 0) {
                  if (!(response.vehicles && response.vehicles.length)) {
                    _message2 = {
                      title: this.$i18n.t('planning.messages.failedInvalidRoutes'),
                      duration: 5000
                    };

                    _elementUi.Notification.warning(_message2);
                  } else {
                    _message3 = {
                      title: this.$i18n.t('planning.messages.successInvalidRoutes'),
                      duration: 5000
                    };

                    _elementUi.Notification.success(_message3);
                  }

                  invalid.forEach(function (item) {
                    var reason = item['reason'];
                    var type = item['type'];
                    var code = item['code'];

                    if (invalidReasons.filter(function (i) {
                      return i['type'] === type;
                    }).length === 0) {
                      invalidReasons.push({
                        reason: reason,
                        code: code,
                        type: type,
                        orderId: item.orderId || [],
                        shipmentReference: item.shipmentReference || [],
                        vehicleId: item.vehicleId || [],
                        plateNumber: item.plateNumber || []
                      });
                    } else {
                      var index = invalidReasons.findIndex(function (i) {
                        return i['type'] === type;
                      });

                      if (index !== -1) {
                        if (item.orderId) {
                          invalidReasons[index]['orderId'].push(item.orderId);
                        }

                        if (item.shipmentReference) {
                          invalidReasons[index]['shipmentReference'].push(item.shipmentReference);
                        }

                        if (item.vehicleId) {
                          invalidReasons[index]['vehicleId'].push(item.vehicleId);
                        }

                        if (item.plateNumber) {
                          invalidReasons[index]['plateNumber'].push(item.plateNumber);
                        }
                      }
                    }
                  });
                }

                return _context2.abrupt("return", {
                  invalidReasons: invalidReasons,
                  invalidOrderIds: response['invalidOrder'],
                  vehicles: response.vehicles
                });

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function manualAssign(_x2, _x3) {
        return _manualAssign.apply(this, arguments);
      }

      return manualAssign;
    }()
  }, {
    key: "autoAssign",
    value: function () {
      var _autoAssign = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(data) {
        var _this11 = this;

        var locationType, vehicles, disabledTrucks, res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // Insert log

                /*this.insertLogs('auto assign', {
                    routeType: 'last-mile-delivery',
                    planDate: this.$planDate,
                     routes: data['orders']
                        ? data['orders'].map((oData) => {
                                return {
                                    shipmentReference: oData['shipmentReference'] || '',
                                    orderId: oData['id'] || '',
                                };
                          })
                        : [],
                    type: this.$locationType,
                     user: this.$userInformation.user,
                    globalUsers: this.$GLOBAL_ACTIVE_USERS,
                });*/
                locationType = this.$locationType && this.$locationType === 'dropoff' ? 'drop' : 'pick';
                vehicles = [];
                disabledTrucks = [];

                if (window.localStorage.getItem(this.disableTruckKey)) {
                  disabledTrucks = window.localStorage.getItem(this.disableTruckKey).split(',');
                }

                this.$trucks.filter(function (truck) {
                  return !_this11.isTruckHasAssignedCompletedOrder(truck['id']);
                }).forEach(function (truck) {
                  var truckObj = _this11.getTruckInPlan(truck['id']);

                  var tType = _this11.helper.get(truckObj, 'type', 'AUTOASSIGN');

                  var obj = _objectSpread(_objectSpread({}, truck), {}, {
                    type: tType,
                    code: truck['id'],
                    zone: truck['zone'],
                    truckCommodityType: truck['truckCommodityType'],
                    plateNumber: truck['plateNumber'],
                    capacity1: parseFloat(truck['weight']),
                    capacity2: parseFloat(truck['volume']),
                    capacity3: parseFloat(truck['assemblyMinutes']),
                    workingHours: truck['workingHours'] || DEFAULT_TRUCK_WORKING_HOURS,
                    driverId: truck['drivers'].length > 0 ? truck['drivers'][0]['id'] : null,
                    vehicleIsLocked: false
                  }); // TODO: new logic
                  // if (!this.isValidTruck(truck) || this.helper.includes(disabledTrucks, truck['id'].toString())) {


                  if (_this11.helper.includes(disabledTrucks, truck['id'].toString())) {
                    obj['vehicleIsLocked'] = true;
                  }

                  if (tType === 'MANUALASSIGN') {
                    // obj['vehicleIsLocked'] = true;
                    // obj['routes'] = [];
                    obj['routes'] = (0, _toConsumableArray2.default)(truckObj['routes']);
                  }

                  vehicles.push(obj);
                });

                if (!(vehicles.length > 0)) {
                  _context3.next = 12;
                  break;
                }

                _context3.next = 8;
                return this.lastMileDeliveryAPI.autoAssign({
                  company: this.$userInformation.company.name,
                  user: this.$userInformation.user.name,
                  code: this.$planDate,
                  startDateTime: this.helper.revertTimezone(data['startTime'], this.$timezone, 'YYYY-MM-DD 00:00:00'),
                  routes: data['orders'],
                  vehicles: this.getAvailableVehicles(vehicles)
                }, {}, locationType);

              case 8:
                res = _context3.sent;
                return _context3.abrupt("return", res.data);

              case 12:
                return _context3.abrupt("return", null);

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function autoAssign(_x4) {
        return _autoAssign.apply(this, arguments);
      }

      return autoAssign;
    }()
  }, {
    key: "isValidTruck",
    value: function isValidTruck(truck) {
      var isTimeWindow = this.$userSetting.default2;
      var truckRoutes = this.helper.get(this.helper.filter(this.$plan.trucks, function (t) {
        return t['truckId'] === truck['id'];
      }), '0.routes', []);
      var truckPercentage = Number(this.$userSetting.default17 || 70);

      if (truckPercentage >= 90) {
        truckPercentage = 90;
      }

      var srtTime = (truck['workingHours'][0] || process.env.VUE_APP_DEFAULT_START_WORKINGHR).split(':');
      var srtSeconds = +srtTime[0] * 60 * 60 + +srtTime[1] * 60 + +srtTime[2];
      var endTime = (truck['workingHours'][1] || process.env.VUE_APP_DEFAULT_END_WORKINGHR).split(':');
      var endSeconds = +endTime[0] * 60 * 60 + +endTime[1] * 60 + +endTime[2];
      var truckLimit = truckPercentage / 100 * Number(endSeconds - srtSeconds);
      var truckWeight = truckPercentage / 100 * Number(truck['weight']);
      var truckVolume = truckPercentage / 100 * Number(truck['volume']);
      var isValid = false;

      if (truckRoutes.length >= 2) {
        var truckLastRouteCount = this.getRouteNumbers(truckRoutes);

        if (truckWeight > Number(truckLastRouteCount['capacity1']) && truckVolume > Number(truckLastRouteCount['capacity2']) && truckLimit > Number(truckLastRouteCount['time']) && 86400 > truckLastRouteCount['time'] // NOTE: if time is morethan 24 hrs
        ) {
          isValid = true;
        }
      } else {
        isValid = true;
      }

      var hasAssignedCompletedRoute = this.helper.some(truckRoutes, function (i) {
        return i.status.toUpperCase() === 'INTRANSIT' || i.status.toUpperCase() === 'COMPLETED';
      });
      return isValid && parseFloat(truck['weight']) > 0 && truck['volume'] > 0 && !hasAssignedCompletedRoute;
    }
  }, {
    key: "disableInvalidTrucks",
    value: function disableInvalidTrucks() {
      var _this12 = this;

      var disabledTrucks = [];

      if (window.localStorage.getItem(this.disableTruckKey)) {
        disabledTrucks = window.localStorage.getItem(this.disableTruckKey).split(',');
      }

      this.$plan.trucks.forEach(function (truck) {
        if (!_this12.isValidTruck(truck)) {
          disabledTrucks.push(truck.truckId.toString());
        }
      });
      this.disableTruckList = this.helper.cloneDeep(disabledTrucks);
      localStorage.setItem(this.disableTruckKey, this.disableTruckList.join(','));
      this.logger.info('Disable Invalid Truck and put it on a local storage', this.disableTruckList);
    }
  }, {
    key: "calculateETA",
    value: function () {
      var _calculateETA = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(payload, type) {
        var routes, sortedRoutes, startTime, res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                routes = this.helper.cloneDeep(payload.routes);
                sortedRoutes = this.helper.cloneDeep(payload.routes).sort(function (a, b) {
                  if (a['runningTime'] > b['runningTime']) {
                    return 1;
                  }

                  if (b['runningTime'] > a['runningTime']) {
                    return -1;
                  }

                  return 0;
                });
                startTime = payload.startTime ? payload.startTime : routes[0].startTime;

                if (type === 'REORDER') {
                  startTime = payload.index === 0 ? sortedRoutes[0].startTime : routes[payload.index].startTime;
                }

                _context4.next = 6;
                return this.lastMileDeliveryAPI.calculateETA({
                  code: this.$planDate,
                  dateTime: startTime,
                  vehicle: [_objectSpread(_objectSpread({}, this.getTruckInPlan(this.$selectedTruck)), {}, {
                    routes: (0, _toConsumableArray2.default)(payload['routes'])
                  })],
                  index: payload.index,
                  locked: payload.isLocked
                });

              case 6:
                res = _context4.sent;

                if (res && !res.failed && !this.helper.isUndefined(res.data)) {
                  _context4.next = 9;
                  break;
                }

                return _context4.abrupt("return", null);

              case 9:
                // Insert log

                /*const title = this.helper.isUndefined(type === 'REORDER') ? 'reorder route' : 'update route eta';
                this.insertLogs(title, {
                    routeType: 'last-mile-delivery',
                    planDate: this.$planDate,
                     truckId: this.$selectedTruck,
                    payload,
                    request: {
                        company: this.$userInformation.company.name,
                        code: this.$planDate,
                        startDateTime: startTime,
                        startIndex: payload.index,
                        routes: this.formatRoutes(routes, true),
                        locked: payload.isLocked,
                        deletedOrders: payload.deletedOrders,
                    },
                    response: res.data,
                     user: this.$userInformation.user,
                    globalUsers: this.$GLOBAL_ACTIVE_USERS,
                });*/
                this.$anyChanges = true;
                return _context4.abrupt("return", res.data);

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function calculateETA(_x5, _x6) {
        return _calculateETA.apply(this, arguments);
      }

      return calculateETA;
    }()
  }, {
    key: "updateCurrentTruck",
    value: function updateCurrentTruck(response) {
      var _this13 = this;

      if (this.$selectedTruck && this.$plan.trucks.length > 0) {
        var plan = this.helper.cloneDeep(this.$plan);
        var index = this.helper.findIndex(plan['trucks'], function (truck) {
          return truck['truckId'] === _this13.$selectedTruck;
        });

        if (index !== -1) {
          if (response.vehicles.length === 0) {
            if (plan.hasOwnProperty('truckId')) {
              plan['truckId'] = plan['truckId'].filter(function (tId) {
                return tId !== _this13.$selectedTruck;
              });
            }

            plan['trucks'].splice(index, 1);
          } else {
            plan['trucks'][index] = _objectSpread(_objectSpread({}, plan['trucks'][index]), this.helper.get(response, 'vehicles.0', {}));
          }
        }

        this.$setPlan({
          plan: plan
        });
      }
    }
  }, {
    key: "isGenerateNewPlanId",
    value: function isGenerateNewPlanId(truckObj) {
      var _this14 = this;

      if (this.helper.every(truckObj.routes, function (i) {
        return i['status'] === 'UNASSIGNED';
      }) && this.helper.every(truckObj.routes, function (i) {
        return _this14.helper.isUndefined(i['planId']);
      })) {
        return true;
      }

      if (this.helper.every(truckObj.routes, function (i) {
        return i['status'] === 'ASSIGNED';
      }) && this.helper.every(truckObj.routes, function (i) {
        return _this14.helper.isUndefined(i['planId']);
      })) {
        return true;
      }

      if (this.helper.some(truckObj.routes, function (i) {
        return i['status'] === 'ASSIGNED';
      }) && this.helper.some(truckObj.routes, function (i) {
        return i['status'] === 'UNASSIGNED';
      })) {
        var assignedRoutes = truckObj.routes.filter(function (r) {
          return r.status === 'ASSIGNED';
        });
        var unassignedRoutes = truckObj.routes.filter(function (r) {
          return r.status === 'UNASSIGNED';
        });
        return this.helper.every(assignedRoutes, function (r) {
          return !_this14.helper.isUndefined(r.planId);
        }) && this.helper.every(unassignedRoutes, function (r) {
          return _this14.helper.isUndefined(r.planId);
        });
      }

      return false;
    }
  }, {
    key: "savePlan",
    value: function () {
      var _savePlan = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _this15 = this;

        var plan,
            isAutoAssign,
            isUpdateSocket,
            isResetPlan,
            bufferPlan,
            i,
            indexes,
            cancelDriverAssignmentResponse,
            m,
            prefix,
            newPlanIds,
            payload,
            message,
            deletePayload,
            deleteRes,
            saveRes,
            _args5 = arguments;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                plan = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : this.$plan;
                isAutoAssign = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : false;
                isUpdateSocket = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : true;
                isResetPlan = _args5.length > 3 && _args5[3] !== undefined ? _args5[3] : true;
                this.isAutoAssignLoading = true;
                this.isManualAssignLoading = true;
                bufferPlan = this.helper.cloneDeep(plan);
                i = 0;
                indexes = [];

                if (!(this.$toBeUnassignedOrderIds.length > 0)) {
                  _context5.next = 17;
                  break;
                }

                _context5.next = 12;
                return this.cancelDriverAssignment(this.$toBeUnassignedOrderIds);

              case 12:
                cancelDriverAssignmentResponse = _context5.sent;

                if (cancelDriverAssignmentResponse) {
                  _context5.next = 17;
                  break;
                }

                this.isAutoAssignLoading = false;
                this.isManualAssignLoading = false;
                return _context5.abrupt("return", false);

              case 17:
                if (!this.$isAssignedDriverChanges) {
                  _context5.next = 23;
                  break;
                }

                m = {
                  title: this.$i18n.t('planning.messages.assignedDriverChanges'),
                  duration: 5000
                };

                _elementUi.Notification.warning(m);

                this.isAutoAssignLoading = false;
                this.isManualAssignLoading = false;
                return _context5.abrupt("return", false);

              case 23:
                this.helper.forEach(bufferPlan['trucks'], function (truck, index) {
                  var isGenerateNewPlanId = _this15.isGenerateNewPlanId(truck);

                  if (isGenerateNewPlanId) {
                    i++;
                    indexes.push(index);
                  }

                  var lastIdxWithPlanId = _this15.helper.findLastIndex(truck.routes, function (route) {
                    return !_this15.helper.isUndefined(route.planId);
                  });

                  var id = lastIdxWithPlanId !== -1 ? truck.routes[lastIdxWithPlanId].planId : null;
                  truck.estimatedDistance = _this15.getRouteDetails(truck.truckId)['estimatedDistance'];
                  truck.estimatedTime = _this15.getRouteDetails(truck.truckId)['estimatedTime'];

                  _this15.helper.forEach(truck['routes'], function (route) {
                    route.isHighlighted = false;

                    if (lastIdxWithPlanId !== -1 && _this15.helper.isUndefined(route.planId) && !isGenerateNewPlanId) {
                      route.planId = id;
                    }
                  });
                });
                prefix = this.helper.generateNewPlanId(this.$userData.planIdFormat, this.$planDate, this.$userInformation, 'lastmile');
                _context5.next = 27;
                return this.routeAPI.generateLoadPlanId(prefix, i);

              case 27:
                newPlanIds = _context5.sent;
                newPlanIds = this.helper.get(newPlanIds, 'data', []);
                this.helper.forEach(indexes, function (value, index) {
                  var id = newPlanIds[index];
                  bufferPlan.trucks[value].routes.forEach(function (route) {
                    if (_this15.helper.isUndefined(route.planId)) {
                      route.planId = id;
                    }
                  });
                  bufferPlan.trucks[value].planId = _this15.helper.uniq(bufferPlan.trucks[value].routes.map(function (x) {
                    return x['planId'];
                  }));
                });
                bufferPlan['planId'] = this.helper.flatten(bufferPlan['trucks'].map(function (truck) {
                  return truck['planId'];
                }));
                payload = {
                  code: bufferPlan['code'],
                  userEmail: this.$userInformation.user.name,
                  data: bufferPlan['trucks'].map(function (tData) {
                    delete tData['drivers'];
                    delete tData['orders'];
                    delete tData['trucks'];
                    tData['routes'].map(function (routeData) {
                      delete routeData['orders'];
                      delete routeData['masterpoints'];
                      delete routeData['waypoints'];
                      return routeData;
                    });
                    return tData;
                  }).filter(function (ia) {
                    return ia.truckId === _this15.$selectedTruck || ia.hasUpdate;
                  })
                };
                message = {
                  title: this.$i18n.t('general.updateSuccess'),
                  duration: 5000
                }; // For transfer plan when trucks become empty

                if (!(this.$removedTruckIds.length > 0)) {
                  _context5.next = 44;
                  break;
                }

                deletePayload = {
                  userEmail: this.$userInformation.user.name,
                  code: this.$plan['code'],
                  truckId: this.$removedTruckIds.toString()
                };
                _context5.next = 37;
                return this.lastMileDeliveryAPI.deletePlan({
                  payload: deletePayload,
                  requestParams: {
                    code: this.$plan['code'],
                    vehicleId: deletePayload['truckId']
                  }
                });

              case 37:
                deleteRes = _context5.sent;

                if (!(!deleteRes || deleteRes.failed)) {
                  _context5.next = 44;
                  break;
                }

                message['title'] = this.$i18n.t('general.updateFailed');

                _elementUi.Notification.error(message);

                this.isAutoAssignLoading = false;
                this.isManualAssignLoading = false;
                return _context5.abrupt("return", false);

              case 44:
                if (!this.$isPlanExists) {
                  _context5.next = 50;
                  break;
                }

                _context5.next = 47;
                return this.lastMileDeliveryAPI.insertPlan(payload);

              case 47:
                saveRes = _context5.sent;
                _context5.next = 53;
                break;

              case 50:
                _context5.next = 52;
                return this.lastMileDeliveryAPI.insertPlan(payload);

              case 52:
                saveRes = _context5.sent;

              case 53:
                if (saveRes && saveRes.data) {
                  _context5.next = 59;
                  break;
                }

                message['title'] = this.$i18n.t('general.updateFailed');

                _elementUi.Notification.error(message);

                this.isAutoAssignLoading = false;
                this.isManualAssignLoading = false;
                return _context5.abrupt("return", false);

              case 59:
                if (isUpdateSocket) {
                  // Socket for global plan
                  this.socketAPI.updateLMDGlobalPlan({
                    userEmail: this.$userInformation.user.name,
                    socketId: this.$socketId,
                    code: this.$planDate
                  }); // Socket for global orders

                  this.socketAPI.updateLMDGlobalSelectedOrders({
                    userEmail: this.$userInformation.user.name,
                    socketId: this.$socketId,
                    orderId: [],
                    dataType: 'removeAll'
                  });
                }

                bufferPlan.trucks.forEach(function (truck) {
                  truck.hasUpdate = false;
                });
                this.$setPlan({
                  plan: bufferPlan
                }); // this.$failedOrders = [];

                if (!isResetPlan) {
                  _context5.next = 65;
                  break;
                }

                _context5.next = 65;
                return this.$resetPlan();

              case 65:
                this.$anyChanges = false;
                this.$isPlanExists = true;
                this.$removedTruckIds = [];

                _elementUi.Notification.success(message);

                if (isAutoAssign) {
                  _context5.next = 72;
                  break;
                }

                _context5.next = 72;
                return this.$getUnassignedOrders();

              case 72:
                this.isAutoAssignLoading = false;
                this.isManualAssignLoading = false; // Insert log

                /*this.insertLogs('save plan', {
                    routeType: 'last-mile-delivery',
                    planDate: this.$planDate,
                     planIds: [...bufferPlan.planId],
                    trucks:
                        bufferPlan && bufferPlan.trucks.length
                            ? bufferPlan.trucks.map((truck) => ({
                                    truckId: truck.truckId,
                                    plateNumber: truck.plateNumber,
                                    driverIds: truck.driverId,
                              }))
                            : [],
                     user: this.$userInformation.user,
                    globalUsers: this.$GLOBAL_ACTIVE_USERS,
                });*/

                return _context5.abrupt("return", true);

              case 75:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function savePlan() {
        return _savePlan.apply(this, arguments);
      }

      return savePlan;
    }()
  }, {
    key: "deleteRoutesInTruck",
    value: function () {
      var _deleteRoutesInTruck = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(args) {
        var isAutoAssign, planId, isSomeOrdersAssigned, shipRefFromOrder, driverAssignPayload, cancelDriverAssignmentResponse, deletePayload, requestParams, deleteRes, message;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this.isAutoAssignLoading = true;
                this.isManualAssignLoading = true;
                isAutoAssign = args['isAutoAssign'] || false;
                planId = args['planId'] || null;
                isSomeOrdersAssigned = false;
                shipRefFromOrder = this.getShipRefsFromOrders();

                if (!(shipRefFromOrder.length === 0)) {
                  _context6.next = 10;
                  break;
                }

                this.isAutoAssignLoading = false;
                this.isManualAssignLoading = false;
                return _context6.abrupt("return", false);

              case 10:
                if (!(this.$plan && this.$plan.trucks && this.$plan.trucks.length >= 1)) {
                  _context6.next = 16;
                  break;
                }

                if (this.currTruck) {
                  _context6.next = 15;
                  break;
                }

                this.isAutoAssignLoading = false;
                this.isManualAssignLoading = false;
                return _context6.abrupt("return", false);

              case 15:
                isSomeOrdersAssigned = this.currPlanTruck['routes'].some(function (route) {
                  return route.status.toUpperCase() === 'ASSIGNED' || route.status.toUpperCase() === 'COMPLETED';
                });

              case 16:
                if (!(isSomeOrdersAssigned && shipRefFromOrder.length >= 1)) {
                  _context6.next = 26;
                  break;
                }

                driverAssignPayload = [];
                shipRefFromOrder.forEach(function (order) {
                  driverAssignPayload.push({
                    shipref: order
                  });
                });
                _context6.next = 21;
                return this.cancelDriverAssignment(driverAssignPayload);

              case 21:
                cancelDriverAssignmentResponse = _context6.sent;

                if (cancelDriverAssignmentResponse) {
                  _context6.next = 26;
                  break;
                }

                this.isAutoAssignLoading = false;
                this.isManualAssignLoading = false;
                return _context6.abrupt("return", false);

              case 26:
                if (!(this.$includedOrders.length >= 1)) {
                  _context6.next = 29;
                  break;
                }

                _context6.next = 29;
                return this.savePlan(this.$plan, false, false);

              case 29:
                deletePayload = {
                  userEmail: this.$userInformation.user.name,
                  code: this.$plan['code'],
                  truckId: this.$selectedTruck
                };
                requestParams = {
                  code: this.$plan['code'],
                  vehicleId: deletePayload['truckId']
                };

                if (!this.helper.isUndefined(planId)) {
                  requestParams['planId'] = planId;
                }

                _context6.next = 34;
                return this.lastMileDeliveryAPI.deletePlan({
                  payload: deletePayload,
                  requestParams: requestParams
                });

              case 34:
                deleteRes = _context6.sent;
                message = {
                  title: this.$i18n.t('general.deleteFailed'),
                  duration: 5000
                };

                if (!(!deleteRes || deleteRes.failed)) {
                  _context6.next = 41;
                  break;
                }

                _elementUi.Notification.error(message);

                this.isAutoAssignLoading = false;
                this.isManualAssignLoading = false;
                return _context6.abrupt("return", false);

              case 41:
                message['title'] = this.$i18n.t('general.deleteSuccess');

                _elementUi.Notification.success(message); // Socket for global plan


                this.socketAPI.updateLMDGlobalPlan({
                  userEmail: this.$userInformation.user.name,
                  socketId: this.$socketId,
                  code: this.$planDate
                }); // Socket for global orders

                this.socketAPI.updateLMDGlobalSelectedOrders({
                  userEmail: this.$userInformation.user.name,
                  socketId: this.$socketId,
                  orderId: [],
                  dataType: 'removeAll'
                });
                this.$anyChanges = false;
                this.$initPlan();

                if (isAutoAssign) {
                  _context6.next = 50;
                  break;
                }

                _context6.next = 50;
                return this.$getUnassignedOrders();

              case 50:
                this.isAutoAssignLoading = false;
                this.isManualAssignLoading = false; // Insert log

                /*this.insertLogs('delete routes in truck', {
                    routeType: 'last-mile-delivery',
                    planDate: this.$planDate,
                     truckId: this.$selectedTruck,
                    truck: this.getTruckInfo(this.$selectedTruck),
                     user: this.$userInformation.user,
                    globalUsers: this.$GLOBAL_ACTIVE_USERS,
                });*/

                return _context6.abrupt("return", true);

              case 53:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function deleteRoutesInTruck(_x7) {
        return _deleteRoutesInTruck.apply(this, arguments);
      }

      return deleteRoutesInTruck;
    }()
  }, {
    key: "getCarPlateFromDriverId",
    value: function getCarPlateFromDriverId(driverId) {
      var driver = this.helper.find(this.$drivers, function (item) {
        return item['RecId'] === driverId;
      });

      if (!this.helper.isUndefined(driver)) {
        return driver['Carplate'];
      }

      return null;
    }
  }, {
    key: "getShipRefsFromOrderId",
    value: function getShipRefsFromOrderId(orderId) {
      var _this16 = this;

      var filteredOrders = this.helper.filter(this.$plan['orders'], function (order) {
        return _this16.helper.includes(orderId, parseInt(order['id'], 10));
      });

      if (filteredOrders.length) {
        return this.helper.map(filteredOrders, 'shipmentReference');
      }

      return [];
    }
  }, {
    key: "getShipRefsFromOrders",
    value: function getShipRefsFromOrders() {
      var _this17 = this;

      var selectedTruck = this.helper.find(this.$plan.trucks, function (truck) {
        return truck['truckId'] === _this17.$selectedTruck;
      });

      if (selectedTruck) {
        return selectedTruck['shipmentReference'];
      }

      return [];
    }
  }, {
    key: "confirmUnsavedChanges",
    value: function confirmUnsavedChanges(to, from, next) {
      var _this18 = this;

      if (this.$anyChanges && to.name !== 'login') {
        var message = this.$i18n.t('planning.messages.unsavedChanges');

        _elementUi.MessageBox.confirm(message, 'Warning', {
          confirmButtonText: this.$i18n.t('pickColumns.confirm'),
          cancelButtonText: this.$i18n.t('pickColumns.cancel'),
          type: 'warning',
          center: true
        }).then(function () {
          _this18.$anyChanges = false;

          _this18.$resetPlan();

          next();
        }).catch(function () {
          next(false);
        });
      } else {
        this.$resetPlan(false);
        next();
      }
    }
  }, {
    key: "assignDriver",
    value: function () {
      var _assignDriver = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(payload) {
        var _this19 = this;

        var res, status, response, iOrders;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                payload.forEach(function (payloadData) {
                  payloadData['handledate'] = _this19.$planDate;
                });
                _context7.next = 3;
                return this.planAPI.assignDriver(payload);

              case 3:
                res = _context7.sent;
                status = this.helper.get(res, 'data.status', 300);
                response = {
                  isSuccess: false,
                  invalidOrders: null
                };

                if (!(!res || res['failed'] || status === 'error' || status === 'error header')) {
                  _context7.next = 10;
                  break;
                }

                iOrders = this.helper.get(res, 'data.errors', []);
                response['invalidOrders'] = iOrders.length ? this.helper.map(iOrders, 'shipref').join(', ') : '-';
                return _context7.abrupt("return", response);

              case 10:
                response['isSuccess'] = true;
                return _context7.abrupt("return", response);

              case 12:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function assignDriver(_x8) {
        return _assignDriver.apply(this, arguments);
      }

      return assignDriver;
    }()
  }, {
    key: "cancelDriverAssignment",
    value: function () {
      var _cancelDriverAssignment = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(payload) {
        var res, status, error, message;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.planAPI.cancelDriverAssignment(payload);

              case 2:
                res = _context8.sent;
                status = this.helper.get(res, 'data.status', 300);
                error = null;
                message = {
                  title: this.$i18n.t('planning.messages.cancelOrdersAssignmentSuccess'),
                  duration: 5000
                };

                if (!(!res || res['failed'] || status === 'error' || status === 'error header')) {
                  _context8.next = 11;
                  break;
                }

                error = this.helper.get(res, 'data.error', null);
                message['message'] = "".concat(this.$i18n.t('planning.messages.cancelOrdersAssignmentFailed'), " ").concat(this.$i18n.t('planning.messages.dueTo'), " ").concat(error);

                _elementUi.Notification.error(message);

                return _context8.abrupt("return", false);

              case 11:
                _elementUi.Notification.success(message);

                return _context8.abrupt("return", true);

              case 13:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function cancelDriverAssignment(_x9) {
        return _cancelDriverAssignment.apply(this, arguments);
      }

      return cancelDriverAssignment;
    }()
  }, {
    key: "getStatusColor",
    value: function getStatusColor(route) {
      var cssClass = {
        'pick-up': route['waypointType'] === 'P',
        unassigned: false,
        assigned: false,
        completed: false
      };
      cssClass[route['status']] = true;
      return cssClass;
    }
  }, {
    key: "isRouteBelongToDifferentUser",
    value: function isRouteBelongToDifferentUser(route) {
      if (!route.hasOwnProperty('user')) {
        return false;
      }

      if (route.hasOwnProperty('user') && this.$userInformation && this.$userInformation.user) {
        return route['user'] !== this.$userInformation.user.name;
      }

      return false;
    }
  }, {
    key: "isPlanIdBelongToDifferentUser",
    value: function isPlanIdBelongToDifferentUser(planId) {
      var _this20 = this;

      var truckId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.$selectedTruck;
      var isAllowEditOtherUserData = this.$userData.updateUserData || false;
      var truck = this.getTruckInPlan(truckId);

      if (this.$selectedTruck && truck) {
        return this.helper.some(truck['routes'], function (route) {
          return route.planId === planId && _this20.isRouteBelongToDifferentUser(route);
        }) && !isAllowEditOtherUserData;
      }

      return false;
    }
  }, {
    key: "createNewPlanIdRoutes",
    value: function () {
      var _createNewPlanIdRoutes = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(_ref) {
        var _this21 = this;

        var planId, startTime, truckId, unassignedOrders, isTransfer, isShowFailedOrders, failedOrders, orders, orderIds, message, truckObj, overideStartDateTime, res, vehicles, invalidReasons, invalidOrderIds;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                planId = _ref.planId, startTime = _ref.startTime, truckId = _ref.truckId, unassignedOrders = _ref.unassignedOrders, isTransfer = _ref.isTransfer;
                isShowFailedOrders = false;
                failedOrders = [];
                orders = this.helper.uniqBy(unassignedOrders.filter(function (order) {
                  return !_this21.isInvalidOrder(order);
                }), function (i) {
                  return i.id;
                });
                orderIds = this.helper.uniq(this.helper.map(orders, 'id'));

                if (!(orders.length === 0)) {
                  _context9.next = 9;
                  break;
                }

                message = {
                  title: this.$i18n.t('planning.messages.cannotAssignEmptyOrder'),
                  duration: 5000
                };

                _elementUi.Notification.warning(message);

                return _context9.abrupt("return", null);

              case 9:
                truckObj = this.getTruckInPlan(truckId);
                overideStartDateTime = null;

                if (truckObj && truckObj['routes'] && truckObj['routes'].length >= 1) {
                  overideStartDateTime = truckObj['routes'][truckObj['routes'].length - 1]['endTime'] || null;
                }

                _context9.next = 14;
                return this.manualAssign({
                  orders: orders,
                  overideStartDateTime: overideStartDateTime || null,
                  startTime: this.helper.isUndefined(startTime) ? this.$defaultTime : startTime,
                  truck: this.getTruckInfo(truckId),
                  planId: planId
                }, isTransfer);

              case 14:
                res = _context9.sent;
                vehicles = this.helper.get(res, 'vehicles.0', null);
                invalidReasons = this.helper.get(res, 'invalidReasons', []);
                invalidOrderIds = this.helper.get(res, 'invalidOrderIds', []);

                if (!this.helper.isUndefined(res)) {
                  _context9.next = 20;
                  break;
                }

                return _context9.abrupt("return", null);

              case 20:
                if (!(this.helper.isUndefined(vehicles) && res.invalidReasons.length > 0 || vehicles && vehicles.routes.length === 0 && res.invalidReasons.length > 0)) {
                  _context9.next = 24;
                  break;
                }

                isShowFailedOrders = true;
                failedOrders = invalidReasons;
                return _context9.abrupt("return", {
                  isShowFailedOrders: isShowFailedOrders,
                  failedOrders: failedOrders
                });

              case 24:
                if (res.invalidReasons.length > 0) {
                  isShowFailedOrders = true;
                  failedOrders = invalidReasons;
                }

                return _context9.abrupt("return", {
                  vehicles: vehicles,
                  orders: orders,
                  orderIds: orderIds,
                  invalidOrderIds: invalidOrderIds,
                  isShowFailedOrders: isShowFailedOrders,
                  failedOrders: failedOrders,
                  selectedOrderIds: orderIds
                });

              case 26:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function createNewPlanIdRoutes(_x10) {
        return _createNewPlanIdRoutes.apply(this, arguments);
      }

      return createNewPlanIdRoutes;
    }()
  }, {
    key: "updateExistingPlanIdRoutes",
    value: function () {
      var _updateExistingPlanIdRoutes = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(_ref2) {
        var _this22 = this;

        var planId, startTime, truckObj, unassignedOrders, isTransfer, isShowFailedOrders, failedOrders, indexOccurence, otherRoutes, selectedOrders, selectedOrderIds, currentOrderIds, orderIds, existingOrders, orders, res, vehicles, invalidReasons, invalidOrderIds;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                planId = _ref2.planId, startTime = _ref2.startTime, truckObj = _ref2.truckObj, unassignedOrders = _ref2.unassignedOrders, isTransfer = _ref2.isTransfer;
                isShowFailedOrders = false;
                failedOrders = [];
                indexOccurence = this.helper.findIndex(truckObj['routes'], function (route) {
                  return route.planId === planId;
                });
                otherRoutes = truckObj['routes'].filter(function (route) {
                  return route.planId !== planId;
                });
                selectedOrders = this.helper.uniqBy(unassignedOrders.filter(function (order) {
                  return !_this22.isInvalidOrder(order);
                }), function (i) {
                  return i.id;
                });
                selectedOrderIds = this.helper.map(selectedOrders, 'id');
                currentOrderIds = this.helper.uniq(this.helper.flatten(truckObj['routes'].filter(function (route) {
                  return route.planId === planId;
                }).map(function (route) {
                  return route['orderId'];
                })));
                orderIds = this.helper.uniq([].concat((0, _toConsumableArray2.default)(currentOrderIds), (0, _toConsumableArray2.default)(selectedOrderIds)));
                existingOrders = this.$plan.orders.filter(function (order) {
                  return _this22.helper.includes(orderIds, order.id);
                });
                orders = this.helper.uniqBy([].concat((0, _toConsumableArray2.default)(existingOrders), (0, _toConsumableArray2.default)(selectedOrders)), function (i) {
                  return i.id;
                });
                _context10.next = 13;
                return this.manualAssign({
                  orders: orders,
                  overideStartDateTime: null,
                  startTime: startTime,
                  truck: this.getTruckInfo(truckObj['truckId']),
                  planId: [planId]
                }, isTransfer);

              case 13:
                res = _context10.sent;
                vehicles = this.helper.get(res, 'vehicles.0', null);
                invalidReasons = this.helper.get(res, 'invalidReasons', []);
                invalidOrderIds = this.helper.get(res, 'invalidOrderIds', []);

                if (!this.helper.isUndefined(res)) {
                  _context10.next = 19;
                  break;
                }

                return _context10.abrupt("return", null);

              case 19:
                if (!(this.helper.isUndefined(vehicles) && res.invalidReasons.length > 0 || vehicles && vehicles.routes.length === 0 && res.invalidReasons.length > 0)) {
                  _context10.next = 23;
                  break;
                }

                isShowFailedOrders = true;
                failedOrders = invalidReasons;
                return _context10.abrupt("return", {
                  isShowFailedOrders: isShowFailedOrders,
                  failedOrders: failedOrders
                });

              case 23:
                if (res.invalidReasons.length > 0) {
                  isShowFailedOrders = true;
                  failedOrders = invalidReasons;
                }

                otherRoutes.splice.apply(otherRoutes, [indexOccurence, 0].concat((0, _toConsumableArray2.default)(res['vehicles'][0]['routes'])));
                return _context10.abrupt("return", {
                  vehicles: _objectSpread(_objectSpread({}, vehicles), {}, {
                    truckId: truckObj['truckId'],
                    locked: false,
                    orderId: this.helper.uniq([].concat((0, _toConsumableArray2.default)(truckObj['orderId']), (0, _toConsumableArray2.default)(orderIds))).filter(function (order) {
                      return !_this22.helper.includes(invalidOrderIds, order);
                    }),
                    planId: this.helper.uniq([].concat((0, _toConsumableArray2.default)(truckObj['planId']), (0, _toConsumableArray2.default)(res['vehicles'][0].planId))),
                    routes: otherRoutes,
                    shipmentReference: this.helper.uniq([].concat((0, _toConsumableArray2.default)(truckObj['shipmentReference']), (0, _toConsumableArray2.default)(res['vehicles'][0].shipmentReference)))
                  }),
                  orders: selectedOrders,
                  orderIds: orderIds,
                  invalidOrderIds: invalidOrderIds,
                  isShowFailedOrders: isShowFailedOrders,
                  failedOrders: failedOrders,
                  selectedOrderIds: selectedOrderIds
                });

              case 26:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function updateExistingPlanIdRoutes(_x11) {
        return _updateExistingPlanIdRoutes.apply(this, arguments);
      }

      return updateExistingPlanIdRoutes;
    }()
  }, {
    key: "adHocV2NewPlanIdRoutes",
    value: function () {
      var _adHocV2NewPlanIdRoutes = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(_ref3) {
        var _this23 = this;

        var planId, startTime, truckId, unassignedOrders, isShowFailedOrders, failedOrders, orders, orderIds, message, res, vehicles, invalidReasons, invalidOrderIds;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                planId = _ref3.planId, startTime = _ref3.startTime, truckId = _ref3.truckId, unassignedOrders = _ref3.unassignedOrders;
                isShowFailedOrders = false;
                failedOrders = [];
                orders = this.helper.uniqBy(unassignedOrders.filter(function (order) {
                  return !_this23.isInvalidOrder(order);
                }), function (i) {
                  return i.id;
                });
                orderIds = this.helper.uniq(this.helper.map(orders, 'id'));

                if (!(orders.length === 0)) {
                  _context11.next = 9;
                  break;
                }

                message = {
                  title: this.$i18n.t('planning.messages.cannotAssignEmptyOrder'),
                  duration: 5000
                };

                _elementUi.Notification.warning(message);

                return _context11.abrupt("return", null);

              case 9:
                _context11.next = 11;
                return this.adhocAssign({
                  orders: orders,
                  startTime: this.helper.isUndefined(startTime) ? this.$defaultTime : startTime,
                  truck: this.getTruckInfo(truckId),
                  planId: [planId]
                }, true);

              case 11:
                res = _context11.sent;
                vehicles = this.helper.get(res, 'vehicles.0', null);
                invalidReasons = this.helper.get(res, 'invalidReasons', []);
                invalidOrderIds = this.helper.get(res, 'invalidOrderIds', []);

                if (!this.helper.isUndefined(res)) {
                  _context11.next = 17;
                  break;
                }

                return _context11.abrupt("return", null);

              case 17:
                if (!(this.helper.isUndefined(vehicles) && res.invalidReasons.length > 0 || vehicles && vehicles.routes.length === 0 && res.invalidReasons.length > 0)) {
                  _context11.next = 21;
                  break;
                }

                isShowFailedOrders = true;
                failedOrders = invalidReasons;
                return _context11.abrupt("return", {
                  isShowFailedOrders: isShowFailedOrders,
                  failedOrders: failedOrders
                });

              case 21:
                if (res.invalidReasons.length > 0) {
                  isShowFailedOrders = true;
                  failedOrders = invalidReasons;
                }

                return _context11.abrupt("return", {
                  vehicles: vehicles,
                  orders: orders,
                  orderIds: orderIds,
                  invalidOrderIds: invalidOrderIds,
                  isShowFailedOrders: isShowFailedOrders,
                  failedOrders: failedOrders,
                  selectedOrderIds: orderIds
                });

              case 23:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function adHocV2NewPlanIdRoutes(_x12) {
        return _adHocV2NewPlanIdRoutes.apply(this, arguments);
      }

      return adHocV2NewPlanIdRoutes;
    }()
  }, {
    key: "adHocV2ExistingPlanIdRoutes",
    value: function () {
      var _adHocV2ExistingPlanIdRoutes = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(_ref4) {
        var _this24 = this;

        var planId, startTime, truckObj, unassignedOrders, isShowFailedOrders, failedOrders, selectedOrders, selectedOrderIds, currentOrderIds, orderIds, existingOrders, orders, param, firstRouteStatus, res, vehicles, invalidReasons, invalidOrderIds;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                planId = _ref4.planId, startTime = _ref4.startTime, truckObj = _ref4.truckObj, unassignedOrders = _ref4.unassignedOrders;
                isShowFailedOrders = false;
                failedOrders = [];
                selectedOrders = this.helper.uniqBy(unassignedOrders.filter(function (order) {
                  return !_this24.isInvalidOrder(order);
                }), function (i) {
                  return i.id;
                });
                selectedOrderIds = this.helper.map(selectedOrders, 'id');
                currentOrderIds = this.helper.uniq(this.helper.flatten(truckObj['routes'].filter(function (route) {
                  return route.planId === planId;
                }).map(function (route) {
                  return route['orderId'];
                })));
                orderIds = this.helper.uniq([].concat((0, _toConsumableArray2.default)(currentOrderIds), (0, _toConsumableArray2.default)(selectedOrderIds)));
                existingOrders = this.$plan.orders.filter(function (order) {
                  return _this24.helper.includes(orderIds, order.id);
                });
                orders = this.helper.uniqBy([].concat((0, _toConsumableArray2.default)(existingOrders), (0, _toConsumableArray2.default)(selectedOrders)), function (i) {
                  return i.id;
                });
                param = {};
                firstRouteStatus = this.helper.get(truckObj, 'routes.0.status', 'UNASSIGNED');

                if (firstRouteStatus === 'ASSIGNED') {
                  param['status'] = 'ASSIGNED';
                }

                _context12.next = 14;
                return this.adhocAssign({
                  orders: selectedOrders,
                  startTime: startTime,
                  truck: truckObj,
                  planId: planId
                }, false, param);

              case 14:
                res = _context12.sent;
                vehicles = this.helper.get(res, 'vehicles.0', null);
                invalidReasons = this.helper.get(res, 'invalidReasons', []);
                invalidOrderIds = this.helper.get(res, 'invalidOrderIds', []);

                if (!this.helper.isUndefined(res)) {
                  _context12.next = 20;
                  break;
                }

                return _context12.abrupt("return", null);

              case 20:
                if (!(this.helper.isUndefined(vehicles) && res.invalidReasons.length > 0 || vehicles && vehicles.routes.length === 0 && res.invalidReasons.length > 0)) {
                  _context12.next = 24;
                  break;
                }

                isShowFailedOrders = true;
                failedOrders = invalidReasons;
                return _context12.abrupt("return", {
                  isShowFailedOrders: isShowFailedOrders,
                  failedOrders: failedOrders
                });

              case 24:
                if (res.invalidReasons.length > 0) {
                  isShowFailedOrders = true;
                  failedOrders = invalidReasons;
                }

                return _context12.abrupt("return", {
                  vehicles: vehicles,
                  orders: orders,
                  orderIds: orderIds,
                  invalidOrderIds: invalidOrderIds,
                  isShowFailedOrders: isShowFailedOrders,
                  failedOrders: failedOrders,
                  selectedOrderIds: selectedOrderIds
                });

              case 26:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function adHocV2ExistingPlanIdRoutes(_x13) {
        return _adHocV2ExistingPlanIdRoutes.apply(this, arguments);
      }

      return adHocV2ExistingPlanIdRoutes;
    }()
  }, {
    key: "handleNewTruckObj",
    value: function () {
      var _handleNewTruckObj = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(args) {
        var _this25 = this;

        var planId, startTime, truckId, unassignedOrders, isTransfer, res, vehicles, orders, orderIds, invalidOrderIds, isShowFailedOrders, failedOrders, selectedOrderIds, truck, plan;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                planId = args.planId;
                startTime = args.startTime || this.$defaultTime;
                truckId = args.truckId || this.$selectedTruck;
                unassignedOrders = args.unassignedOrders || this.$selectedOrders;
                isTransfer = this.helper.get(args, 'isTransfer', false);
                _context13.next = 7;
                return this.createNewPlanIdRoutes({
                  planId: planId,
                  startTime: startTime,
                  truckId: truckId,
                  unassignedOrders: unassignedOrders,
                  isTransfer: isTransfer
                });

              case 7:
                res = _context13.sent;

                if (!this.helper.isUndefined(res)) {
                  _context13.next = 10;
                  break;
                }

                return _context13.abrupt("return");

              case 10:
                vehicles = res.vehicles, orders = res.orders, orderIds = res.orderIds, invalidOrderIds = res.invalidOrderIds, isShowFailedOrders = res.isShowFailedOrders, failedOrders = res.failedOrders, selectedOrderIds = res.selectedOrderIds;

                if (!(this.helper.isUndefined(vehicles) && isShowFailedOrders && failedOrders.length > 0)) {
                  _context13.next = 13;
                  break;
                }

                return _context13.abrupt("return", {
                  isShowFailedOrders: isShowFailedOrders,
                  failedOrders: failedOrders
                });

              case 13:
                truck = _objectSpread(_objectSpread({}, vehicles), {}, {
                  truckId: truckId,
                  locked: false
                });
                plan = this.helper.cloneDeep(this.$plan);
                plan.orders = this.helper.uniqBy([].concat((0, _toConsumableArray2.default)(plan.orders), (0, _toConsumableArray2.default)(orders)).filter(function (order) {
                  return !_this25.helper.includes(res.invalidOrderIds, order.id);
                }), 'id');
                plan.planId = [].concat((0, _toConsumableArray2.default)(this.helper.flatten(plan.trucks.map(function (i) {
                  return i['planId'];
                }))), [planId]);
                plan.trucks.push(truck);
                this.$setPlan({
                  plan: plan
                });
                _context13.next = 21;
                return this.updateOrderTable(orderIds, invalidOrderIds, selectedOrderIds);

              case 21:
                this.logger.info('Init Truck: ', truck, 'Plan: ', plan);
                return _context13.abrupt("return", {
                  isShowFailedOrders: isShowFailedOrders,
                  failedOrders: failedOrders
                });

              case 23:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function handleNewTruckObj(_x14) {
        return _handleNewTruckObj.apply(this, arguments);
      }

      return handleNewTruckObj;
    }()
  }, {
    key: "handleExistingTruckObj",
    value: function () {
      var _handleExistingTruckObj = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(args) {
        var _this26 = this;

        var planId, isNewPlanId, truckObj, unassignedOrders, isTransfer, truckIndex, startTime, res, isShowFailedOrders, failedOrders, truck, plan;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                planId = args.planId;
                isNewPlanId = args.isNewPlanId || false;
                truckObj = args.truckObj || null;
                unassignedOrders = args.unassignedOrders || this.$selectedOrders;
                isTransfer = this.helper.get(args, 'isTransfer', false);
                truckIndex = this.helper.findIndex(this.$plan.trucks, function (t) {
                  return t['truckId'] === truckObj['truckId'];
                });
                startTime = this.routes[this.routes.length - 1]['endTime'];

                if (!isNewPlanId) {
                  _context14.next = 13;
                  break;
                }

                _context14.next = 10;
                return this.createNewPlanIdRoutes({
                  planId: planId,
                  startTime: startTime,
                  truckId: truckObj['truckId'],
                  unassignedOrders: unassignedOrders,
                  isTransfer: isTransfer
                });

              case 10:
                _context14.t0 = _context14.sent;
                _context14.next = 16;
                break;

              case 13:
                _context14.next = 15;
                return this.updateExistingPlanIdRoutes({
                  planId: planId,
                  startTime: this.$defaultTime,
                  truckObj: truckObj,
                  unassignedOrders: unassignedOrders,
                  isTransfer: isTransfer
                });

              case 15:
                _context14.t0 = _context14.sent;

              case 16:
                res = _context14.t0;

                if (!this.helper.isUndefined(res)) {
                  _context14.next = 19;
                  break;
                }

                return _context14.abrupt("return");

              case 19:
                isShowFailedOrders = res.isShowFailedOrders;
                failedOrders = res.failedOrders;
                truck = null;

                if (!(this.helper.isUndefined(res['vehicles']) && isShowFailedOrders && failedOrders.length > 0)) {
                  _context14.next = 24;
                  break;
                }

                return _context14.abrupt("return", {
                  isShowFailedOrders: isShowFailedOrders,
                  failedOrders: failedOrders
                });

              case 24:
                if (isNewPlanId) {
                  truck = _objectSpread(_objectSpread({}, res['vehicles']), {}, {
                    truckId: truckObj['truckId'],
                    locked: false,
                    driverId: [].concat((0, _toConsumableArray2.default)(truckObj['driverId']), (0, _toConsumableArray2.default)(res['vehicles']['driverId'])),
                    orderId: [].concat((0, _toConsumableArray2.default)(truckObj['orderId']), (0, _toConsumableArray2.default)(res['orderIds'])).filter(function (order) {
                      return !_this26.helper.includes(res.invalidOrderIds, order);
                    }),
                    planId: [].concat((0, _toConsumableArray2.default)(truckObj['planId']), (0, _toConsumableArray2.default)(res['vehicles'].planId)),
                    projectCode: this.helper.uniq([].concat((0, _toConsumableArray2.default)(truckObj['projectCode']), (0, _toConsumableArray2.default)(res['vehicles'].projectCode))),
                    routes: [].concat((0, _toConsumableArray2.default)(truckObj['routes']), (0, _toConsumableArray2.default)(res['vehicles'].routes)),
                    shipmentReference: [].concat((0, _toConsumableArray2.default)(truckObj['shipmentReference']), (0, _toConsumableArray2.default)(res['vehicles'].shipmentReference))
                  });
                } else {
                  truck = res['vehicles'];
                }

                plan = this.helper.cloneDeep(this.$plan);
                plan.orders = this.helper.uniqBy([].concat((0, _toConsumableArray2.default)(plan.orders), (0, _toConsumableArray2.default)(res['orders'])).filter(function (order) {
                  return !_this26.helper.includes(res.invalidOrderIds, order.id);
                }), 'id');

                if (isNewPlanId) {
                  plan.planId = [].concat((0, _toConsumableArray2.default)(this.helper.flatten(plan.trucks.map(function (i) {
                    return i['planId'];
                  }))), [planId]);
                }

                plan.trucks[truckIndex] = truck;
                this.$setPlan({
                  plan: plan
                });
                _context14.next = 32;
                return this.updateOrderTable(res['orderIds'], res['invalidOrderIds'], res['selectedOrderIds']);

              case 32:
                this.logger.info('Update Truck: ', truck, 'Plan: ', plan);
                return _context14.abrupt("return", {
                  isShowFailedOrders: isShowFailedOrders,
                  failedOrders: failedOrders
                });

              case 34:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function handleExistingTruckObj(_x15) {
        return _handleExistingTruckObj.apply(this, arguments);
      }

      return handleExistingTruckObj;
    }()
  }, {
    key: "handleAdhocV2NewTruckObj",
    value: function () {
      var _handleAdhocV2NewTruckObj = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(args) {
        var _this27 = this;

        var planId, startTime, truckId, unassignedOrders, res, vehicles, orders, orderIds, invalidOrderIds, isShowFailedOrders, failedOrders, selectedOrderIds, truck, plan;
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                planId = args.planId;
                startTime = args.startTime || this.$defaultTime;
                truckId = args.truckId || this.$selectedTruck;
                unassignedOrders = args.unassignedOrders || this.$selectedOrders;
                _context15.next = 6;
                return this.adHocV2NewPlanIdRoutes({
                  planId: planId,
                  startTime: startTime,
                  truckId: truckId,
                  unassignedOrders: unassignedOrders
                });

              case 6:
                res = _context15.sent;

                if (!this.helper.isUndefined(res)) {
                  _context15.next = 9;
                  break;
                }

                return _context15.abrupt("return");

              case 9:
                vehicles = res.vehicles, orders = res.orders, orderIds = res.orderIds, invalidOrderIds = res.invalidOrderIds, isShowFailedOrders = res.isShowFailedOrders, failedOrders = res.failedOrders, selectedOrderIds = res.selectedOrderIds;

                if (!(this.helper.isUndefined(vehicles) && isShowFailedOrders && failedOrders.length > 0)) {
                  _context15.next = 12;
                  break;
                }

                return _context15.abrupt("return", {
                  isShowFailedOrders: isShowFailedOrders,
                  failedOrders: failedOrders
                });

              case 12:
                truck = _objectSpread(_objectSpread({}, vehicles), {}, {
                  truckId: truckId,
                  locked: false
                });
                plan = this.helper.cloneDeep(this.$plan);
                plan.orders = this.helper.uniqBy([].concat((0, _toConsumableArray2.default)(plan.orders), (0, _toConsumableArray2.default)(orders)).filter(function (order) {
                  return !_this27.helper.includes(invalidOrderIds, order.id);
                }), 'id');
                plan.planId = [].concat((0, _toConsumableArray2.default)(this.helper.flatten(plan.trucks.map(function (i) {
                  return i['planId'];
                }))), [planId]);
                plan.trucks.push(truck);
                this.$setPlan({
                  plan: plan
                });
                _context15.next = 20;
                return this.updateOrderTable(orderIds, invalidOrderIds, selectedOrderIds);

              case 20:
                this.logger.info('Init Truck with completed order(s): ', truck, 'Plan: ', plan);
                return _context15.abrupt("return", {
                  isShowFailedOrders: isShowFailedOrders,
                  failedOrders: failedOrders
                });

              case 22:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function handleAdhocV2NewTruckObj(_x16) {
        return _handleAdhocV2NewTruckObj.apply(this, arguments);
      }

      return handleAdhocV2NewTruckObj;
    }()
  }, {
    key: "handleAdhocV2ExistingTruckObj",
    value: function () {
      var _handleAdhocV2ExistingTruckObj = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(args) {
        var _this28 = this;

        var planId, truckObj, unassignedOrders, truckIndex, res, vehicles, orders, orderIds, invalidOrderIds, isShowFailedOrders, failedOrders, selectedOrderIds, truck, plan, firstRouteStatus, isAssignDriver, payload, oIds, orderShipRefs, currentDriver, carPlate;
        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                planId = args.planId;
                truckObj = args.truckObj || null;
                unassignedOrders = args.unassignedOrders || this.$selectedOrders;
                truckIndex = this.helper.findIndex(this.$plan.trucks, function (t) {
                  return t['truckId'] === truckObj['truckId'];
                });
                _context16.next = 6;
                return this.adHocV2ExistingPlanIdRoutes({
                  planId: planId,
                  startTime: this.$defaultTime,
                  truckObj: truckObj,
                  unassignedOrders: unassignedOrders
                });

              case 6:
                res = _context16.sent;

                if (!this.helper.isUndefined(res)) {
                  _context16.next = 9;
                  break;
                }

                return _context16.abrupt("return");

              case 9:
                vehicles = res.vehicles, orders = res.orders, orderIds = res.orderIds, invalidOrderIds = res.invalidOrderIds, isShowFailedOrders = res.isShowFailedOrders, failedOrders = res.failedOrders, selectedOrderIds = res.selectedOrderIds;

                if (!(this.helper.isUndefined(vehicles) && isShowFailedOrders && failedOrders.length > 0)) {
                  _context16.next = 12;
                  break;
                }

                return _context16.abrupt("return", {
                  isShowFailedOrders: isShowFailedOrders,
                  failedOrders: failedOrders
                });

              case 12:
                truck = _objectSpread({}, vehicles);
                plan = this.helper.cloneDeep(this.$plan);
                plan.orders = this.helper.uniqBy([].concat((0, _toConsumableArray2.default)(plan.orders), (0, _toConsumableArray2.default)(orders)).filter(function (order) {
                  return !_this28.helper.includes(invalidOrderIds, order.id);
                }), 'id');
                plan.trucks[truckIndex] = truck;
                this.$setPlan({
                  plan: plan
                });
                /**
                 * Assume auto assign to the driver
                 * If not move this to savePlan
                 * */

                firstRouteStatus = this.helper.get(truck, 'routes.0.status', 'UNASSIGNED');
                isAssignDriver = firstRouteStatus === 'ASSIGNED' && !isShowFailedOrders && failedOrders.length === 0;
                payload = [];

                if (!isAssignDriver) {
                  _context16.next = 28;
                  break;
                }

                oIds = this.helper.get(truck, 'orderId', []);
                orderShipRefs = this.getShipRefsFromOrderId(oIds);
                currentDriver = this.helper.get(truck, 'routes.0.driverId', 'UNASSIGNED');
                carPlate = this.getCarPlateFromDriverId(currentDriver);

                if (!(this.helper.isUndefined(carPlate) || orderShipRefs.length === 0)) {
                  _context16.next = 27;
                  break;
                }

                return _context16.abrupt("return");

              case 27:
                orderShipRefs.forEach(function (order) {
                  payload.push({
                    shipref: order,
                    drivercode: carPlate,
                    truckrecid: plan.trucks[truckIndex].truckId
                  });
                });

              case 28:
                _context16.next = 30;
                return this.updateOrderTable(orderIds, invalidOrderIds, selectedOrderIds);

              case 30:
                this.logger.info('Update Truck with completed orders: ', truck, 'Plan: ', plan);
                return _context16.abrupt("return", {
                  isShowFailedOrders: isShowFailedOrders,
                  failedOrders: failedOrders,
                  isAssignDriver: isAssignDriver,
                  assignDriverPayload: payload
                });

              case 32:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function handleAdhocV2ExistingTruckObj(_x17) {
        return _handleAdhocV2ExistingTruckObj.apply(this, arguments);
      }

      return handleAdhocV2ExistingTruckObj;
    }()
  }, {
    key: "updateOrderTable",
    value: function () {
      var _updateOrderTable = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee17(orderIds, invalidOrderIds, selectedOrderIds) {
        var _this29 = this;

        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                this.$selectedOrders = [];
                this.$excludedOrders = this.helper.uniq([].concat((0, _toConsumableArray2.default)(this.$excludedOrders), (0, _toConsumableArray2.default)(orderIds.filter(function (oId) {
                  return !_this29.helper.includes(invalidOrderIds, oId);
                }))));
                this.$includedOrders = this.helper.uniq([].concat((0, _toConsumableArray2.default)(this.$includedOrders), (0, _toConsumableArray2.default)(orderIds.filter(function (oId) {
                  return _this29.helper.includes(invalidOrderIds, oId);
                }))).filter(function (oId) {
                  return !_this29.helper.includes(selectedOrderIds, oId);
                }));
                _context17.next = 5;
                return this.$getUnassignedOrders();

              case 5:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function updateOrderTable(_x18, _x19, _x20) {
        return _updateOrderTable.apply(this, arguments);
      }

      return updateOrderTable;
    }()
  }, {
    key: "getRouteDetails",
    value: function getRouteDetails(truckId) {
      var truck = this.helper.get(this.helper.filter(this.$plan.trucks, function (t) {
        return t['truckId'] === truckId;
      }), '0', null);

      if (!truck) {
        return {
          estimatedDistance: 0,
          estimatedTime: 0
        };
      }

      if (truck && truck.routes && truck.routes.length > 0) {
        return {
          estimatedDistance: this.helper.sumBy(truck.routes, 'distance') || 0,
          estimatedTime: this.helper.sumBy(truck.routes, 'time') || 0
        };
      }

      return {
        estimatedDistance: 0,
        estimatedTime: 0
      };
    }
  }, {
    key: "isOrderIdExistInGlobal",
    value: function isOrderIdExistInGlobal(orderId) {
      var _this30 = this;

      return !!this.helper.find(this.$GLOBAL_SELECTED_ORDERS, function (o) {
        return o.orderId === orderId && o.userId !== _this30.$userInformation.user.id;
      });
    }
  }, {
    key: "getGlobalOrderInfo",
    value: function getGlobalOrderInfo(orderId, fieldName) {
      var _this31 = this;

      var obj = this.helper.find(this.$GLOBAL_SELECTED_ORDERS, function (o) {
        return o.orderId === orderId && o.userId !== _this31.$userInformation.user.id;
      });

      if (!obj) {
        return '';
      }

      return obj[fieldName];
    }
  }, {
    key: "isTruckIdExistInGlobal",
    value: function isTruckIdExistInGlobal(truckId) {
      var _this32 = this;

      return !!this.helper.find(this.$GLOBAL_SELECTED_TRUCKS, function (o) {
        return o.truckId === truckId && _this32.$userInformation && _this32.$userInformation.user && o.userId !== _this32.$userInformation.user.id;
      });
    }
  }, {
    key: "getGlobalTruckInfo",
    value: function getGlobalTruckInfo(truckId, fieldName) {
      var _this33 = this;

      var obj = this.helper.find(this.$GLOBAL_SELECTED_TRUCKS, function (o) {
        return o.truckId === truckId && _this33.$userInformation && _this33.$userInformation.user && o.userId !== _this33.$userInformation.user.id;
      });

      if (!obj) {
        return '';
      }

      return obj[fieldName];
    }
  }, {
    key: "isPlanSyncWithGlobal",
    value: function isPlanSyncWithGlobal(data) {
      return data['socketId'] !== this.$socketId;
    }
  }, {
    key: "updatePlanFromSocket",
    value: function () {
      var _updatePlanFromSocket = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee18(data) {
        var _this34 = this;

        var globalPlan, bufferPlan, myTruck, orders, trucks;
        return regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                this.$truckLoading = true;
                globalPlan = data;

                if (this.isPlanSyncWithGlobal(data)) {
                  _context18.next = 5;
                  break;
                }

                this.$truckLoading = false;
                return _context18.abrupt("return");

              case 5:
                if (!(this.$plan.trucks.length > 0 && globalPlan === null)) {
                  _context18.next = 13;
                  break;
                }

                this.$setPlan({
                  isReset: true
                });
                this.$resetPlan();
                this.$isPlanExists = false;
                _context18.next = 11;
                return this.$getUnassignedOrders();

              case 11:
                this.$truckLoading = false;
                return _context18.abrupt("return");

              case 13:
                bufferPlan = this.helper.cloneDeep(this.$plan);

                if (this.$selectedTruck && this.$plan.trucks.length > 0) {
                  myTruck = this.currPlanTruck;
                  orders = this.helper.uniq([].concat((0, _toConsumableArray2.default)(bufferPlan['orders']), (0, _toConsumableArray2.default)(globalPlan['orders'])), 'id');
                  trucks = [myTruck].concat((0, _toConsumableArray2.default)(globalPlan['vehicles'].filter(function (t) {
                    return t.truckId !== _this34.$selectedTruck;
                  })));
                  bufferPlan['planId'] = this.helper.flatten(trucks.map(function (i) {
                    return i.planId;
                  }));
                  bufferPlan['orderId'] = orders.map(function (i) {
                    return i.id;
                  });
                  bufferPlan['orders'] = orders;
                  bufferPlan['truckId'] = trucks.map(function (i) {
                    return i.truckId;
                  });
                  bufferPlan['trucks'] = trucks;
                } else {
                  bufferPlan = {
                    code: globalPlan['code'],
                    planDate: globalPlan['code'],
                    planId: this.helper.flatten(globalPlan['vehicles'].map(function (i) {
                      return i.planId;
                    })),
                    orderId: globalPlan['orderIds'],
                    orders: globalPlan['orders'],
                    truckId: globalPlan['vehicles'].map(function (i) {
                      return i.truckId;
                    }),
                    trucks: globalPlan['vehicles'] || []
                  };
                }

                this.$setPlan({
                  plan: bufferPlan
                });
                this.$isPlanExists = true;
                _context18.next = 19;
                return this.$getUnassignedOrders();

              case 19:
                this.$truckLoading = false;

              case 20:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function updatePlanFromSocket(_x21) {
        return _updatePlanFromSocket.apply(this, arguments);
      }

      return updatePlanFromSocket;
    }()
  }, {
    key: "getAvailableVehicles",
    value: function getAvailableVehicles() {
      var _this35 = this;

      var vehileData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var finalVehicle = [];
      vehileData.forEach(function (vData) {
        if (!vData['vehicleIsLocked']) {
          var currentTruck = _this35.$plan.trucks.find(function (t) {
            return t['truckId'] === vData['code'];
          });

          if (currentTruck && currentTruck['routes'].length >= 1) {
            if (!currentTruck['routes'].find(function (ct) {
              return ct['status'] === 'ASSIGNED';
            })) {
              vData['orders'] = _this35.getCleanOrders(currentTruck['orderId'] || [], _this35.$plan.orders);
              vData['vehicleEndRunningTime'] = currentTruck['routes'].length >= 1 ? currentTruck['routes'][currentTruck['routes'].length - 1]['endRunningTime'] : 0;
            }
          } else {
            vData['orders'] = [];
          }

          if (vData['type'] === 'MANUALASSIGN') {
            vData['orders'] = [];
            delete vData['vehicleEndRunningTime'];
          }
        } else {
          vData['orders'] = [];
        }

        finalVehicle.push(vData);
      });
      return finalVehicle;
    }
  }, {
    key: "getCleanOrders",
    value: function getCleanOrders() {
      var orderId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var orders = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      if (orderId.length >= 1 && orders.length >= 1) {
        return orders.filter(function (oData) {
          return orderId.includes(Number(oData['id']));
        });
      }

      return [];
    }
  }, {
    key: "getRouteNumbers",
    value: function getRouteNumbers(routes) {
      var routeNumber = {
        capacity1: 0,
        capacity2: 0,
        time: 1800,
        routeCount: routes.length
      };
      routes.forEach(function (rData) {
        routeNumber['capacity1'] = routeNumber['capacity1'] + Number(rData['capacity1'] || 0);
        routeNumber['capacity2'] = routeNumber['capacity2'] + Number(rData['capacity2'] || 0);
        routeNumber['time'] = routeNumber['time'] + Number(rData['time'] || 0) + Number(rData['handlingTime'] || 0) + Number(rData['waitingTime'] || 0);
      });
      return routeNumber;
    }
  }, {
    key: "isTruckOrderSentToWarehouse",
    value: function isTruckOrderSentToWarehouse() {
      var truckId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$selectedTruck;

      if (!truckId) {
        return false;
      }

      var truck = this.getTruckInPlan(truckId);
      return this.helper.get(truck, 'sendToWarehouse', false);
    }
  }, {
    key: "isTruckHasAssignedCompletedOrder",
    value: function isTruckHasAssignedCompletedOrder() {
      var truckId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$selectedTruck;

      if (!truckId) {
        return false;
      }

      var truck = this.getTruckInPlan(truckId);

      if (!truck || !truck['routes']) {
        return false;
      }

      return this.helper.some(truck['routes'], function (i) {
        return i.status === 'ASSIGNED' || i.status === 'COMPLETED';
      });
    }
  }]);
  return LastMileDeliveryMixin;
}((0, _vuePropertyDecorator.Mixins)(_helper.HelperMixin, _logger.LoggerMixin, _userLogs.UserLogsMixin));

exports.LastMileDeliveryMixin = LastMileDeliveryMixin;
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userSetting', {
  namespace: 'authentication'
})], LastMileDeliveryMixin.prototype, "$userSetting", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('lfToken', {
  namespace: 'authentication'
})], LastMileDeliveryMixin.prototype, "$lfToken", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('lfCustKey', {
  namespace: 'authentication'
})], LastMileDeliveryMixin.prototype, "$lfCustKey", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('lfAPIToken', {
  namespace: 'authentication'
})], LastMileDeliveryMixin.prototype, "$lfAPIToken", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('drivers', {
  namespace: 'common'
})], LastMileDeliveryMixin.prototype, "$drivers", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('plan', {
  namespace: 'lastMileDeliveryWellcome'
})], LastMileDeliveryMixin.prototype, "$plan", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('defaultPagination', {
  namespace: 'lastMileDeliveryWellcome'
})], LastMileDeliveryMixin.prototype, "$defaultPagination", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('defaultOrderColumns', {
  namespace: 'lastMileDeliveryWellcome'
})], LastMileDeliveryMixin.prototype, "$defaultOrderColumns", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('tableLoading', {
  namespace: 'lastMileDeliveryWellcome'
})], LastMileDeliveryMixin.prototype, "$tableLoading", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('orderLocationLists', {
  namespace: 'lastMileDeliveryWellcome'
})], LastMileDeliveryMixin.prototype, "$orderLocationLists", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('defaultLocationType', {
  namespace: 'lastMileDeliveryWellcome'
})], LastMileDeliveryMixin.prototype, "$defaultLocationType", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('isOccupied', {
  namespace: 'lastMileDeliveryWellcome'
})], LastMileDeliveryMixin.prototype, "$isOccupied", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('occupyingUsername', {
  namespace: 'lastMileDeliveryWellcome'
})], LastMileDeliveryMixin.prototype, "$occupyingUsername", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('occupyingRoute', {
  namespace: 'lastMileDeliveryWellcome'
})], LastMileDeliveryMixin.prototype, "$occupyingRoute", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_IS_MOBILE', {
  namespace: 'common'
})], LastMileDeliveryMixin.prototype, "$setIsMobile", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_SOCKET_ID', {
  namespace: 'common'
})], LastMileDeliveryMixin.prototype, "$setSocketId", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_TO_BE_UNASSIGNED_ORDER_IDS', {
  namespace: 'lastMileDeliveryWellcome'
})], LastMileDeliveryMixin.prototype, "$setToBeUnassignedOrderIds", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_PLAN_DATE', {
  namespace: 'lastMileDeliveryWellcome'
})], LastMileDeliveryMixin.prototype, "$setPlanDate", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_DATE_RANGE_OPTION', {
  namespace: 'lastMileDeliveryWellcome'
})], LastMileDeliveryMixin.prototype, "$setDateRangeOption", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_TABLE_LOADING', {
  namespace: 'lastMileDeliveryWellcome'
})], LastMileDeliveryMixin.prototype, "$setTableLoading", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_EXCLUDED_ORDERS', {
  namespace: 'lastMileDeliveryWellcome'
})], LastMileDeliveryMixin.prototype, "$setExcludedOrders", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_INCLUDED_ORDERS', {
  namespace: 'lastMileDeliveryWellcome'
})], LastMileDeliveryMixin.prototype, "$setIncludedOrders", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_SELECTED_ORDERS', {
  namespace: 'lastMileDeliveryWellcome'
})], LastMileDeliveryMixin.prototype, "$setSelectedOrders", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_SELECTED_DRIVER', {
  namespace: 'lastMileDeliveryWellcome'
})], LastMileDeliveryMixin.prototype, "$setSelectedDriver", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_SELECTED_TRUCK', {
  namespace: 'lastMileDeliveryWellcome'
})], LastMileDeliveryMixin.prototype, "$setSelectedTruck", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_TRUCK_LOADING', {
  namespace: 'lastMileDeliveryWellcome'
})], LastMileDeliveryMixin.prototype, "$setTruckLoading", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_DISABLE_TRUCK_LIST', {
  namespace: 'lastMileDeliveryWellcome'
})], LastMileDeliveryMixin.prototype, "$setDisableTruckList", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_TRUCKS', {
  namespace: 'lastMileDeliveryWellcome'
})], LastMileDeliveryMixin.prototype, "$setTrucks", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_BUFFER_TRUCKS', {
  namespace: 'lastMileDeliveryWellcome'
})], LastMileDeliveryMixin.prototype, "$setBufferTrucks", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_ANY_CHANGES', {
  namespace: 'lastMileDeliveryWellcome'
})], LastMileDeliveryMixin.prototype, "$setAnyChanges", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_PLAN_EXISTS', {
  namespace: 'lastMileDeliveryWellcome'
})], LastMileDeliveryMixin.prototype, "$setPlanExists", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_PAGINATION', {
  namespace: 'lastMileDeliveryWellcome'
})], LastMileDeliveryMixin.prototype, "$setPagination", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_ORDER_FILTERS', {
  namespace: 'lastMileDeliveryWellcome'
})], LastMileDeliveryMixin.prototype, "$setOrderFilters", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_SELECTED_COLUMNS', {
  namespace: 'lastMileDeliveryWellcome'
})], LastMileDeliveryMixin.prototype, "$setSelectedColumns", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_TRUCK_FILTERS', {
  namespace: 'lastMileDeliveryWellcome'
})], LastMileDeliveryMixin.prototype, "$setTruckFilters", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_UNASSIGNED_ORDERS', {
  namespace: 'lastMileDeliveryWellcome'
})], LastMileDeliveryMixin.prototype, "$setUnassignedOrders", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_LOCATION_TYPE', {
  namespace: 'lastMileDeliveryWellcome'
})], LastMileDeliveryMixin.prototype, "$setLocationType", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_SELECTED_LOCATION', {
  namespace: 'lastMileDeliveryWellcome'
})], LastMileDeliveryMixin.prototype, "$setSelectedLocation", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_SEARCH_TYPE', {
  namespace: 'lastMileDeliveryWellcome'
})], LastMileDeliveryMixin.prototype, "$setSearchType", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_MANUAL_ASSIGN_LOADING', {
  namespace: 'lastMileDeliveryWellcome'
})], LastMileDeliveryMixin.prototype, "$setIsManualAssignLoading", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_AUTO_ASSIGN_LOADING', {
  namespace: 'lastMileDeliveryWellcome'
})], LastMileDeliveryMixin.prototype, "$setIsAutoAssignLoading", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_ASSIGNED_DRIVER_CHANGES', {
  namespace: 'lastMileDeliveryWellcome'
})], LastMileDeliveryMixin.prototype, "$setIsAssignedDriverChanges", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_FAILED_ORDERS', {
  namespace: 'lastMileDeliveryWellcome'
})], LastMileDeliveryMixin.prototype, "$setFailedOrders", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_ORDER_COLUMN_TEMPLATES', {
  namespace: 'lastMileDeliveryWellcome'
})], LastMileDeliveryMixin.prototype, "$setOrderColumnTemplates", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_GLOBAL_ACTIVE_USERS', {
  namespace: 'lastMileDeliveryWellcome'
})], LastMileDeliveryMixin.prototype, "$setGlobalActiveUsers", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_GLOBAL_SELECTED_ORDERS', {
  namespace: 'lastMileDeliveryWellcome'
})], LastMileDeliveryMixin.prototype, "$setGlobalSelectedOrders", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_GLOBAL_SELECTED_TRUCKS', {
  namespace: 'lastMileDeliveryWellcome'
})], LastMileDeliveryMixin.prototype, "$setGlobalSelectedTrucks", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_START_DATE', {
  namespace: 'lastMileDeliveryWellcome'
})], LastMileDeliveryMixin.prototype, "$setStartDate", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_END_DATE', {
  namespace: 'lastMileDeliveryWellcome'
})], LastMileDeliveryMixin.prototype, "$setEndDate", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_REMOVED_TRUCK_IDS', {
  namespace: 'lastMileDeliveryWellcome'
})], LastMileDeliveryMixin.prototype, "$setRemovedTruckIds", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_IS_OCCUPIED', {
  namespace: 'lastMileDeliveryWellcome'
})], LastMileDeliveryMixin.prototype, "$setIsOccupied", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_OCCUPYING_USERNAME', {
  namespace: 'lastMileDeliveryWellcome'
})], LastMileDeliveryMixin.prototype, "$setOccupyingUsername", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_OCCUPYING_ROUTE', {
  namespace: 'lastMileDeliveryWellcome'
})], LastMileDeliveryMixin.prototype, "$setOccupyingRoute", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Action)('resetPlan', {
  namespace: 'lastMileDeliveryWellcome'
})], LastMileDeliveryMixin.prototype, "$resetPlan", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Action)('initPlan', {
  namespace: 'lastMileDeliveryWellcome'
})], LastMileDeliveryMixin.prototype, "$initPlan", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Action)('setPlan', {
  namespace: 'lastMileDeliveryWellcome'
})], LastMileDeliveryMixin.prototype, "$setPlan", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Action)('getUnassignedOrders', {
  namespace: 'lastMileDeliveryWellcome'
})], LastMileDeliveryMixin.prototype, "$getUnassignedOrders", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Action)('setDateRange', {
  namespace: 'lastMileDeliveryWellcome'
})], LastMileDeliveryMixin.prototype, "$setDateRange", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Action)('deletePlan', {
  namespace: 'lastMileDeliveryWellcome'
})], LastMileDeliveryMixin.prototype, "$deletePlan", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Action)('getTrucks', {
  namespace: 'lastMileDeliveryWellcome'
})], LastMileDeliveryMixin.prototype, "$getTrucks", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Action)('getOrderLocationLists', {
  namespace: 'lastMileDeliveryWellcome'
})], LastMileDeliveryMixin.prototype, "$getOrderLocationLists", void 0);
exports.LastMileDeliveryMixin = LastMileDeliveryMixin = (0, _tslib.__decorate)([_vuePropertyDecorator.Component], LastMileDeliveryMixin);